import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, TableRow, Table, TableHead, TableContainer, Paper, TableBody, Checkbox, TableCell, FormControlLabel, FormHelperText, CircularProgress, Tooltip, IconButton, Menu, Chip, Avatar, Collapse, InputAdornment, Divider, List, ListItem, ListItemText } from "@material-ui/core";

import { Card, Box, Typography } from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import ActivityService from "./Locality/Service/activityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import SubActivityService from "./Locality/Service/subActivityService";
import StudentService from "./Locality/Service/studentService";
import SuperActivityService from "./Locality/Service/superActivityService";
import * as Yup from 'yup';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import LanguageIcon from '@material-ui/icons/Language';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import HistoryIcon from '@material-ui/icons/History';
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import Skeleton from "@material-ui/lab/Skeleton";
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import Switch from "@material-ui/core/Switch";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import ExportExcel from "../../Excelexport";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import PersonIcon from "@material-ui/icons/Person";
import CheckIcon from "@material-ui/icons/Check";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import EventIcon from "@material-ui/icons/Event";

import SchoolIcon from "@material-ui/icons/School";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import NoteIcon from "@material-ui/icons/Note";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import VideocamIcon from "@material-ui/icons/Videocam";
import PrintIcon from "@material-ui/icons/Print";
import ImagesStoreService from "./Locality/Service/imagesStoreService";
const KEY_DISPLAY_LABELS = {
    P: 'Presented',
    WA: 'Work with Assist',
    WI: 'Work Independent',
    M: 'Master',
};

const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const formatPrintDate = (dateString) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) {
            const parts = String(dateString).split('-');
            if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
            return String(dateString);
        }
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return String(dateString || '');
    }
};

const getFilteredGroupRecords = (group, groupIndex, {
    matchesActivityFilters,
    studentKeyFilters,
    getStudentGroupKey,
}) => {
    const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
    const records = (group.activityRecordsId || [])
        .filter(isActivityRecord)
        .filter((activity) => matchesActivityFilters(activity, studentName));
    if (records.length === 0) return [];

    const studentKey = getStudentGroupKey(group, groupIndex);
    const activeKeyFilter = studentKeyFilters[studentKey];
    const displayRecords = activeKeyFilter
        ? records.filter((rec) => {
            const idx = getActivityKeyIndex(rec.key);
            return activeKeyFilter === 'notSet'
                ? idx === -1
                : KEY_SEQUENCE[idx] === activeKeyFilter;
        })
        : records;

    return displayRecords.map((activity) => ({ group, activity, studentName }));
};

const buildPrintRowsFromGroups = (groups, filterCtx) => {
    const rows = [];
    (groups || []).forEach((group, groupIndex) => {
        getFilteredGroupRecords(group, groupIndex, filterCtx).forEach(({ group: g, activity, studentName }) => {
            rows.push({
                studentName,
                className: g.classId?.className || activity.classId?.className || '',
                sectionName: activity.sectionId?.sectionName || g.sectionId?.sectionName || '',
                areaOfWork: activity.superActivityId?.superActivityName || '',
                listOfActivities: activity.activityId?.activityName || '',
                exercise: activity.subActivityId?.subActivityName || '',
                key: KEY_DISPLAY_LABELS[activity.key] || activity.key || '—',
                observation: activity.remarks || '',
                startDate: formatPrintDate(activity.date),
                endDate: formatPrintDate(activity.endDate),
                status: String(activity.publicStatus || '').toLowerCase() === 'publish' ? 'Published' : 'Draft',
            });
        });
    });
    return rows;
};

const buildActivityPrintHtml = ({ title, subtitle, filterLines, rows, generatedAt }) => {
    const headers = [
        'Student',
        'Class',
        'Section',
        'Area Of Work',
        'Activity',
        'Exercise',
        'Key',
        'Observation',
        'Start Date',
        'End Date',
      
    ];
    const headerHtml = headers.map((h) => `<th>${escapeHtml(h)}</th>`).join('');
    const bodyHtml = rows.map((row) => `
        <tr>
            <td>${escapeHtml(row.studentName)}</td>
            <td>${escapeHtml(row.className)}</td>
            <td>${escapeHtml(row.sectionName)}</td>
            <td>${escapeHtml(row.areaOfWork)}</td>
            <td>${escapeHtml(row.listOfActivities)}</td>
            <td>${escapeHtml(row.exercise)}</td>
            <td>${escapeHtml(row.key)}</td>
            <td>${escapeHtml(row.observation)}</td>
            <td>${escapeHtml(row.startDate)}</td>
            <td>${escapeHtml(row.endDate)}</td>
            
        </tr>
    `).join('');
    const filtersHtml = (filterLines || [])
        .map((line) => `<div class="filter-line">${escapeHtml(line)}</div>`)
        .join('');

    return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1"/>
    <title>${escapeHtml(title)}</title>
    <style>
      * { box-sizing: border-box; }
      body { margin: 0; padding: 24px; font-family: Arial, Helvetica, sans-serif; background: #fff; color: #0f2d4d; }
      .wrap { max-width: 1200px; margin: 0 auto; }
      .header { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 16px; }
      .title { margin: 0; font-size: 22px; font-weight: 800; color: #0f2d4d; }
      .subtitle { margin: 4px 0 0; font-size: 13px; color: #64748b; }
      .meta { font-size: 12px; color: #64748b; text-align: right; white-space: nowrap; }
      .filters { display: flex; flex-wrap: wrap; gap: 8px 16px; margin-bottom: 16px; padding: 12px 14px; border: 1px solid #e6eaf0; border-radius: 10px; background: #f8fafc; }
      .filter-line { font-size: 12px; color: #46566b; font-weight: 600; }
      table { width: 100%; border-collapse: collapse; font-size: 11px; }
      th, td { border: 1px solid #d9dee7; padding: 8px 6px; text-align: left; vertical-align: top; }
      th { background: #f4f6fa; color: #46566b; font-weight: 700; }
      tr:nth-child(even) td { background: #fbfcfe; }
      @media print {
        body { padding: 0; }
        .wrap { max-width: none; }
        @page { size: landscape; margin: 12mm; }
      }
    </style>
  </head>
  <body>
    <div class="wrap">
      <div class="header">
        <div>
          <h1 class="title">${escapeHtml(title)}</h1>
          <p class="subtitle">${escapeHtml(subtitle)}</p>
        </div>
        <div class="meta">Generated: ${escapeHtml(generatedAt)}</div>
      </div>
      <div class="filters">${filtersHtml}</div>
      <table>
        <thead><tr>${headerHtml}</tr></thead>
        <tbody>${bodyHtml}</tbody>
      </table>
    </div>
    <script>window.onload = () => { window.focus(); window.print(); };</script>
  </body>
</html>`;
};

const normalizeRefId = (value) => {
    if (!value) return '';
    if (typeof value === 'object' && value._id) return String(value._id);
    return String(value);
};

const normalizeStudentIds = (recordStudentId, groupStudentId) => {
    const raw = recordStudentId ?? groupStudentId;
    if (!raw) return [];
    if (Array.isArray(raw)) {
        return raw.map((item) => normalizeRefId(item)).filter(Boolean);
    }
    return [normalizeRefId(raw)].filter(Boolean);
};

const isActivityRecord = (record) => Boolean(record && typeof record === 'object' && record._id);

const buildExportRows = (groups) => {
    const rows = [];
    (groups || []).forEach((group) => {
        const studentName = group.studentId
            ? `${group.studentId.firstName} ${group.studentId.lastName}`
            : '';
        const className = group.classId?.className || '';

        (group.activityRecordsId || []).forEach((activity) => {
            if (!isActivityRecord(activity)) return;
            rows.push({
                "Student Name": studentName,
                "Class Name": className,
                "Area Of Work": activity.superActivityId?.superActivityName || '',
                "List Of Activities": activity.activityId?.activityName || '',
                "Exercise": activity.subActivityId?.subActivityName || '',
                "Observation": activity.remarks || '',
                "Key": activity.key,
                "Date": activity.date || '',
            });
        });
    });
    return rows;
};

const getActivityRowKey = (activity, group, index) => {
    if (activity?._id) return String(activity._id);
    const studentPart = normalizeRefId(group?.studentId);
    const activityPart = normalizeRefId(activity?.activityId);
    const subPart = normalizeRefId(activity?.subActivityId) || 'none';
    return `${studentPart}-${activityPart}-${subPart}-${index}`;
};

const mergeActivityRecordUpdate = (existing, updated) => {
    if (!existing || !updated) return existing;
    return {
        ...existing,
        key: Object.prototype.hasOwnProperty.call(updated, 'key') ? updated.key : existing.key,
        publicStatus: updated.publicStatus ?? existing.publicStatus,
        statusHistory: updated.statusHistory ?? existing.statusHistory,
        remarks: updated.remarks ?? existing.remarks,
        date: updated.date ?? existing.date,
        endDate: updated.endDate ?? existing.endDate,
        authorizedPerson: updated.authorizedPerson ?? existing.authorizedPerson,
        imageURL: updated.imageURL ?? existing.imageURL,
        videoURL: updated.videoURL ?? existing.videoURL,
    };
};

const MAX_ACTIVITY_IMAGES = 10;
const MAX_ACTIVITY_VIDEOS = 5;
const IMAGES_STORE_ALL_KEY = 'ALL';
const VIDEO_EXT = /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?|$)/i;

const getMediaTypeFromUrl = (url) => {
    if (!url) return 'image';
    const lower = String(url).split('?')[0].toLowerCase();
    return VIDEO_EXT.test(lower) ? 'video' : 'image';
};

const getActivityImageUrls = (activity) => {
    if (!activity) return [];
    if (Array.isArray(activity.imageURL)) return activity.imageURL.filter(Boolean);
    return activity.imageURL ? [activity.imageURL] : [];
};

const getActivityVideoUrls = (activity) => {
    if (!activity) return [];
    if (Array.isArray(activity.videoURL)) return activity.videoURL.filter(Boolean);
    return activity.videoURL ? [activity.videoURL] : [];
};

const countStoreMedia = (rows) => (rows || []).reduce(
    (acc, row) => ({
        images: acc.images + (row.imageURL?.length || 0),
        videos: acc.videos + (row.videoURL?.length || 0),
    }),
    { images: 0, videos: 0 },
);

const getVisibleStoreMedia = (rows, selectedStoreId) => {
    const filtered = selectedStoreId === IMAGES_STORE_ALL_KEY
        ? rows
        : rows.filter((row) => row._id === selectedStoreId);

    const imageItems = filtered.flatMap((row) =>
        (row.imageURL || [])
            .map((url) => ({
                url: String(url || '').trim(),
                storeEventName: row.eventName || '—',
                storeRecordId: row._id,
                mediaType: 'image',
            }))
            .filter((item) => item.url),
    );

    const videoItems = filtered.flatMap((row) =>
        (row.videoURL || [])
            .map((url) => ({
                url: String(url || '').trim(),
                storeEventName: row.eventName || '—',
                storeRecordId: row._id,
                mediaType: 'video',
            }))
            .filter((item) => item.url),
    );

    return [...imageItems, ...videoItems];
};

const getFileNameFromUrl = (url) => {
    try {
        const path = (url || '').split('/').pop() || url;
        return (path || '').split('?')[0] || 'image';
    } catch {
        return 'image';
    }
};

const downloadFromUrl = async (url, filename) => {
    if (!url) return;
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename || getFileNameFromUrl(url));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename || getFileNameFromUrl(url));
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

const applyActivityRecordPatch = (groups, activityId, apiRecord, hideMastered) => {
    const targetId = String(activityId);
    const shouldRemove = hideMastered && apiRecord?.key === 'M';

    return groups.map((group) => {
        const records = group.activityRecordsId || [];
        const recordIndex = records.findIndex(
            (record) => isActivityRecord(record) && String(record._id) === targetId
        );
        if (recordIndex < 0) return group;

        if (shouldRemove) {
            return {
                ...group,
                activityRecordsId: records.filter((_, index) => index !== recordIndex),
            };
        }

        const nextRecords = [...records];
        nextRecords[recordIndex] = mergeActivityRecordUpdate(records[recordIndex], apiRecord);
        return { ...group, activityRecordsId: nextRecords };
    });
};

const KEY_SEQUENCE = ['P', 'WA', 'WI', 'M'];

const KEY_CIRCLE_COLORS = {
    P: '#1a9b54',
    WA: '#1769d6',
    WI: '#7c4dff',
    M: '#d4a017',
};

const KEY_INCOMPLETE_COLOR = '#c5cdd8';
const KEY_INCOMPLETE_LABEL = '#b8c2cf';

const KEY_STEP_META = {
    P: { shortLabel: 'Present', Icon: CheckIcon },
    WA: { shortLabel: 'Work with Assist', Icon: PeopleOutlineIcon },
    WI: { shortLabel: 'Work Independent', Icon: PersonIcon },
    M: { shortLabel: 'Master', Icon: StarBorderIcon },
};

const normalizeActivityKey = (key) => String(key ?? '').trim();

const getActivityKeyIndex = (key) => {
    const normalized = normalizeActivityKey(key);
    if (!normalized) return -1;
    return KEY_SEQUENCE.indexOf(normalized);
};

const KEY_LEGEND_ITEMS = [
    {
        key: 'P',
        title: 'Present',
        description: 'Student is present. Default status.',
        color: '#1a9b54',
        bg: '#eefbf3',
        Icon: CheckIcon,
    },
    {
        key: 'WA',
        title: 'Work with Assist',
        description: 'Student requires some assistance.',
        color: '#1769d6',
        bg: '#eef4ff',
        Icon: PeopleOutlineIcon,
    },
    {
        key: 'WI',
        title: 'Work Independent',
        description: 'Student can work independently.',
        color: '#e6a23c',
        bg: '#fff8ed',
        Icon: PersonIcon,
    },
    {
        key: 'M',
        title: 'Master',
        description: 'Student has mastered this skill.',
        color: '#7c3aed',
        bg: '#f5f0ff',
        Icon: StarBorderIcon,
        badge: 'Final',
    },
];

const normalizeDialogMessage = (message) => {
    if (message == null) return '';
    if (typeof message === 'string') return message;
    if (Array.isArray(message)) {
        return message.map((item) => normalizeDialogMessage(item)).filter(Boolean).join('\n');
    }
    if (typeof message === 'object') {
        if (message.message != null) return normalizeDialogMessage(message.message);
    }
    return String(message);
};

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    infoNote: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        borderRadius: 8,
        backgroundColor: theme.palette.type === 'light' ? 'rgba(25, 118, 210, 0.08)' : 'rgba(25, 118, 210, 0.16)',
        border: `1px solid ${theme.palette.type === 'light' ? 'rgba(25, 118, 210, 0.24)' : 'rgba(25, 118, 210, 0.4)'}`,
    },
    infoNoteIcon: {
        color: theme.palette.info.main,
        marginTop: 2,
        flexShrink: 0,
    },
    infoNoteText: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        lineHeight: 1.5,
    },
    infoNoteLabel: {
        fontWeight: 600,
        color: theme.palette.info.dark || theme.palette.primary.main,
        marginBottom: 2,
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#0f2d4d',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#6b7280',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    planBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: '8px 18px',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#eef4ff',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1769d6',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filtersTopRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
    },
    filtersChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '6px 12px',
        borderRadius: 8,
        border: '1px solid #d9dee7',
        backgroundColor: '#f7f9fc',
        cursor: 'pointer',
        fontWeight: 600,
        color: '#0f2d4d',
        userSelect: 'none',
    },
    quickRangeWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        backgroundColor: '#f1f4f9',
        borderRadius: 10,
        padding: 4,
    },
    quickRangeBtn: {
        textTransform: 'none',
        borderRadius: 8,
        padding: '4px 12px',
        minWidth: 'auto',
        color: '#46566b',
        fontWeight: 600,
        fontSize: '0.82rem',
    },
    quickRangeBtnActive: {
        backgroundColor: '#fff',
        color: '#1769d6',
        boxShadow: '0 1px 4px rgba(16,42,67,0.12)',
    },
    exportBtn: {
        backgroundColor: '#0f2d4d',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        '&:hover': { backgroundColor: '#0b2238' },
    },
    fieldLabel: {
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    applyBtn: {
        backgroundColor: '#1769d6',
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        '&:hover': { backgroundColor: '#125bbd' },
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
        border: '1px solid #d9dee7',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
    },
    iconBtnOutlined: {
        border: '1px solid #d9dee7',
        borderRadius: 8,
        padding: 8,
        color: '#46566b',
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #e6eaf0',
        boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
        overflow: 'hidden',
    },
    skeletonBar: {
        backgroundColor: 'rgba(15, 45, 77, 0.08)',
    },
    tableSkeletonPagination: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        padding: theme.spacing(1, 2),
        borderTop: '1px solid #e6eaf0',
    },
    groupHeaderRow: {
        backgroundColor: '#eef4ff',
    },
    groupHeaderCell: {
        padding: '10px 16px !important',
        cursor: 'pointer',
        userSelect: 'none',
    },
    groupHeaderInner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    studentAvatar: {
        width: 28,
        height: 28,
        backgroundColor: '#1769d6',
    },
    classChip: {
        backgroundColor: '#e8f0fe',
        color: '#1769d6',
        fontWeight: 600,
        borderRadius: 6,
    },
    dateCell: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        color: '#46566b',
        whiteSpace: 'nowrap',
    },
    statusDraft: {
        backgroundColor: '#e8f0fe',
        color: '#1769d6',
        fontWeight: 600,
        borderRadius: 6,
        cursor: 'pointer',
    },
    statusPublished: {
        backgroundColor: '#e6f7ed',
        color: '#1a9b54',
        fontWeight: 600,
        borderRadius: 6,
        cursor: 'pointer',
    },
    observationIconAction: {
        color: '#1769d6',
        padding: 6,
    },
    observationCell: {
        verticalAlign: 'middle',
        textAlign: 'center',
    },
    observationIconWrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 40,
    },
    noteExpandRow: {
        backgroundColor: '#f8fafc',
        '& td': {
            borderBottom: '1px solid #e6eaf0',
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
        },
    },
    noteExpandBox: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1, 1.5),
        borderRadius: 10,
        border: '1px solid #e6eaf0',
        backgroundColor: '#fff',
    },
    imagesStoreLeftPanel: {
        border: '1px solid #e6eaf0',
        borderRadius: 10,
        overflow: 'hidden',
        maxHeight: 360,
        overflowY: 'auto',
    },
    imagesStoreListItem: {
        '&.Mui-selected': {
            backgroundColor: '#eef4ff',
        },
    },
    imagesStoreGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(88px, 1fr))',
        gap: theme.spacing(1),
        maxHeight: 360,
        overflowY: 'auto',
        padding: theme.spacing(0.5),
    },
    imagesStoreCard: {
        position: 'relative',
        borderRadius: 8,
        border: '2px solid transparent',
        cursor: 'pointer',
        overflow: 'hidden',
        '&:hover': {
            borderColor: '#cfe0fb',
        },
    },
    imagesStoreCardSelected: {
        borderColor: '#1769d6',
    },
    imagesStoreCardDisabled: {
        opacity: 0.45,
        cursor: 'not-allowed',
    },
    imagesStoreThumb: {
        width: '100%',
        height: 72,
        objectFit: 'cover',
        display: 'block',
    },
    imagesStoreVideoThumb: {
        width: '100%',
        height: 72,
        backgroundColor: '#0f2d4d',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    imagesStoreCheck: {
        position: 'absolute',
        top: 4,
        right: 4,
        color: '#1769d6',
        backgroundColor: '#fff',
        borderRadius: '50%',
    },
    activityCountBadge: {
        backgroundColor: '#fff',
        color: '#1769d6',
        border: '1px solid #cfe0fb',
        borderRadius: 12,
        padding: '1px 10px',
        fontSize: '0.72rem',
        fontWeight: 700,
        marginLeft: 8,
    },
    planDialogPaper: {
        borderRadius: 14,
        width: 330,
        maxWidth: '95vw',
        margin: theme.spacing(2, 'auto'),
        boxSizing: 'border-box',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(1.75, 2),
        borderBottom: '1px solid #eef1f5',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    dialogBody: {
        padding: theme.spacing(2),
        overflowX: 'hidden',
        boxSizing: 'border-box',
    },
    dialogFooter: {
        padding: theme.spacing(1.25, 2),
        borderTop: '1px solid #eef1f5',
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
        border: '1px solid #d9dee7',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
    },
    formSection: {
        marginBottom: theme.spacing(2),
    },
    sectionLabel: {
        fontWeight: 700,
        color: '#46566b',
        fontSize: '0.72rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: theme.spacing(1.25),
    },
    dateRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        columnGap: theme.spacing(1.5),
        alignItems: 'start',
    },
    dateFieldWrap: {
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    dateFieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
        lineHeight: 1.2,
        minHeight: 18,
    },
    dateField: {
        width: '100%',
        margin: 0,
        '& .MuiOutlinedInput-root': {
            width: '100%',
            height: 40,
        },
        '& .MuiOutlinedInput-input': {
            padding: '8px 10px',
            fontSize: '0.8125rem',
        },
        '& input[type="date"]': {
            width: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
        },
        '& .MuiFormHelperText-root': {
            minHeight: 20,
            marginTop: 4,
            marginLeft: 0,
            fontSize: '0.72rem',
            lineHeight: 1.3,
        },
    },
    activityTreeWrap: {
        border: '1px solid #e6eaf0',
        borderRadius: 10,
        padding: theme.spacing(1),
        maxHeight: 280,
        overflowY: 'auto',
        backgroundColor: '#fafbfc',
    },
    keyStepRow: {
        display: 'inline-flex',
        alignItems: 'flex-start',
        gap: 2,
    },
    keyStepItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
        minWidth: 52,
        padding: '3px 2px 2px',
        borderRadius: 8,
        userSelect: 'none',
    },
    keyStepItemDoneP: {
        backgroundColor: '#e6f7ed',
    },
    keyStepIconWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        borderRadius: '50%',
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    keyStepLabel: {
        fontSize: '0.58rem',
        fontWeight: 600,
        lineHeight: 1.15,
        textAlign: 'center',
        maxWidth: 58,
    },
    keyStepClickable: {
        cursor: 'pointer',
        '&:hover $keyStepIconWrap': {
            boxShadow: '0 0 0 2px rgba(23,105,214,0.25)',
        },
    },
    keyStepDisabled: {
        cursor: 'default',
    },
    keyLegendWrap: {
        display: 'inline-flex',
        alignItems: 'stretch',
        flexWrap: 'wrap',
        gap: 6,
        marginLeft: theme.spacing(0.5),
    },
    keyLegendCard: {
        display: 'inline-flex',
        alignItems: 'flex-start',
        gap: 6,
        padding: '5px 8px',
        borderRadius: 8,
        maxWidth: 168,
        minWidth: 0,
    },
    keyLegendIcon: {
        width: 22,
        height: 22,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginTop: 1,
    },
    keyLegendText: {
        minWidth: 0,
        flex: 1,
    },
    keyLegendTitleRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 4,
    },
    keyLegendTitle: {
        fontSize: '0.68rem',
        fontWeight: 700,
        lineHeight: 1.2,
    },
    keyLegendDesc: {
        fontSize: '0.58rem',
        color: '#6b7280',
        lineHeight: 1.25,
        marginTop: 1,
    },
    keyLegendBadge: {
        fontSize: '0.52rem',
        fontWeight: 700,
        padding: '1px 5px',
        borderRadius: 4,
        lineHeight: 1.3,
        whiteSpace: 'nowrap',
    },
}));
export default function StudentActivity() {
    const classes = useStyles();
    const history = useHistory();
    const [openHistory, setOpenHistory] = useState(false);
    const [selectedHistory, setSelectedHistory] = useState([]);
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [checkedActivities, setCheckedActivities] = useState([]);
    const [selectedActivityMap, setSelectedActivityMap] = useState({});  // Store relationships between sub-activities and their parents
    const [checkedSubActivities, setCheckedSubActivities] = useState([]);
    const [existingKeySet, setExistingKeySet] = useState(new Set());
    const [existingKeyStudents, setExistingKeyStudents] = useState({});
    const [showOnlyExisting, setShowOnlyExisting] = useState(false);
    /** Tap/click info icon to show note (mobile has no hover; Tooltip alone fails). */
    const [activityNoteDialog, setActivityNoteDialog] = useState({ open: false, title: "", text: "" });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [openMessageDialog, setOpenMessageDialog] = useState(false);
    const [messageDialogContent, setMessageDialogContent] = useState({ title: '', message: '', type: 'info' });
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [selectedTableActivityIds, setSelectedTableActivityIds] = useState([]);
    const [statusConfirmDialog, setStatusConfirmDialog] = useState({
        open: false,
        activity: null,
        publicStatus: '',
    });
    const [keyUpdateDialog, setKeyUpdateDialog] = useState({
        open: false,
        activity: null,
        currentKey: '',
        nextKey: '',
        currentLabel: '',
        nextLabel: '',
        deselect: false,
    });
    const [updatingKeyId, setUpdatingKeyId] = useState(null);
    const [uploadingImageId, setUploadingImageId] = useState(null);
    const [deletingMediaKey, setDeletingMediaKey] = useState(null);
    const [printing, setPrinting] = useState(false);
    const [observationExpanded, setObservationExpanded] = useState({});
    const [imagesExpanded, setImagesExpanded] = useState({});
    const [observationDialog, setObservationDialog] = useState({
        open: false,
        activity: null,
        text: '',
        saving: false,
    });
    const [imagesStoreDialog, setImagesStoreDialog] = useState({
        open: false,
        activity: null,
        loading: false,
        saving: false,
        error: '',
        imagesStoreRows: [],
        selectedStoreId: IMAGES_STORE_ALL_KEY,
        selectedUrls: [],
    });
    const [imageAddMenu, setImageAddMenu] = useState({
        anchorEl: null,
        activity: null,
        uploadInputId: '',
    });
    const [openUnmasteredDialog, setOpenUnmasteredDialog] = useState(false);
    const [unmasteredActivitiesList, setUnmasteredActivitiesList] = useState([]);
    const [pendingFormValues, setPendingFormValues] = useState(null);
    const [pendingResetForm, setPendingResetForm] = useState(null);
    const [groupedUnmasteredActivities, setGroupedUnmasteredActivities] = useState({}); // Grouped by studentId._id
    const [filteredUnmasteredActivities, setFilteredUnmasteredActivities] = useState([]); // Activities for selected students

    const [activityList, setActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [subActivityList, setSubActivityList] = useState([]);
    const [studentReportList, setStudentReportList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [activityIdList, setActivityIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isAdd, setIsAdd] = React.useState(false);
    const [subActivityIdList, setSubActivityIdList] = useState([]);
    const [addActivityList, setAddActivityList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [startDate1, setStartDate1] = useState('');
    const [endDate1, setEndDate1] = useState('');
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [sectionId, setSectionId] = useState('');
    const [dialogSectionList, setDialogSectionList] = useState([]);
    const [studentReportResult, setStudentReportResult] = useState([]);
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const today = new Date();
    const [keyList, setKeyList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [addActivityLoading, setAddActivityLoading] = useState(false);
    /** Per-student table sections: true = expanded; omitted/false = collapsed */
    const [studentActivityRowsExpanded, setStudentActivityRowsExpanded] = useState({});
    /** Per-student key filter: studentKey -> 'P'|'WA'|'WI'|'M'|'notSet' (or undefined for all) */
    const [studentKeyFilters, setStudentKeyFilters] = useState({});

    const getStudentGroupKey = (group, index) =>
        String(group?.studentId?._id ?? group?.studentId ?? `idx-${index}`);

    const isStudentActivityExpanded = (key) => studentActivityRowsExpanded[key] === true;

    const toggleStudentActivityRows = (key) => {
        setStudentActivityRowsExpanded((prev) => ({
            ...prev,
            [key]: !(prev[key] === true),
        }));
    };

    const toggleStudentKeyFilter = (studentKey, keyValue) => {
        setStudentKeyFilters((prev) => {
            const next = { ...prev };
            if (next[studentKey] === keyValue) {
                delete next[studentKey];
            } else {
                next[studentKey] = keyValue;
            }
            return next;
        });
        setStudentActivityRowsExpanded((prev) => ({ ...prev, [studentKey]: true }));
    };

    const collapseAllStudentActivityRows = () => setStudentActivityRowsExpanded({});

    // ---- New UI state for the redesigned Activity Planner screen ----
    const [noteOpen, setNoteOpen] = useState(true);
    const [filtersOpen, setFiltersOpen] = useState(true);
    const [quickRange, setQuickRange] = useState('custom');
    const [moreFiltersOpen, setMoreFiltersOpen] = useState(false);
    const [statusFilter, setStatusFilter] = useState('all');
    const [keyFilter, setKeyFilter] = useState('all');
    const [tableSearch, setTableSearch] = useState('');
    const [tableSearchDebounced, setTableSearchDebounced] = useState('');
    const [highlightPrevWeek, setHighlightPrevWeek] = useState(true);
    const fetchRequestIdRef = useRef(0);
    const filterDebounceRef = useRef(null);
    const searchDebounceRef = useRef(null);
    /** false = hide mastered (M) activities in API; true = include all keys */
    const [showMaster, setShowMaster] = useState(false);
    const [activityTableLoading, setActivityTableLoading] = useState(true);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(20);
    // Total number of student groups on the server (drives TablePagination
    // count now that paging happens server-side).
    const [activityTotal, setActivityTotal] = useState(0);
    useEffect(() => {
        if (rpg > 100) setrpg(100);
    }, [rpg]);
    // Latest committed page/rowsPerPage, read synchronously by refreshActivityTable
    // so it can request the right server page without being re-created on every
    // page change (which would otherwise retrigger the debounced filter effect).
    const pgRef = useRef(pg);
    pgRef.current = pg;
    const rpgRef = useRef(rpg);
    rpgRef.current = rpg;
    const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
    const [howItWorksOpen, setHowItWorksOpen] = useState(false);
    const [actionMenu, setActionMenu] = useState({ anchorEl: null, activity: null, group: null });
    const [visibleCols, setVisibleCols] = useState({
        areaOfWork: true,
        listOfActivities: true,
        exercises: true,
        key: true,
        startDate: true,
        endDate: true,
        status: true,
        images: true,
        observation: true,
    });

    const columnConfig = [
        { id: 'areaOfWork', label: 'Area Of Work' },
        { id: 'listOfActivities', label: 'List Of Activities' },
        { id: 'exercises', label: 'Exercises' },
        { id: 'key', label: 'Key' },
        { id: 'observation', label: 'Observation' },
        { id: 'startDate', label: 'Start Date' },
        { id: 'endDate', label: 'End Date' },
       
        { id: 'status', label: 'Status' },
        { id: 'images', label: 'Images' },
    ];

    const openActionMenu = (event, activity, group) => {
        setActionMenu({ anchorEl: event.currentTarget, activity, group });
    };
    const closeActionMenu = () => setActionMenu({ anchorEl: null, activity: null, group: null });

    const isActivityPublishedToParent = (activity) =>
        String(activity?.publicStatus || '').toLowerCase() === 'publish';

    // Filter a single activity record against the More Filters + table search
    const matchesActivityFilters = (activity, studentName) => {
        if (statusFilter !== 'all') {
            const isDraft = !isActivityPublishedToParent(activity);
            if (statusFilter === 'draft' && !isDraft) return false;
            if (statusFilter === 'published' && isDraft) return false;
        }
        if (keyFilter !== 'all' && activity.key !== keyFilter) return false;
        const term = tableSearchDebounced.trim().toLowerCase();
        if (term) {
            const haystack = [
                studentName,
                activity.classId?.className,
                activity.sectionId?.sectionName,
                activity.superActivityId?.superActivityName,
                activity.activityId?.activityName,
                activity.subActivityId?.subActivityName,
                activity.remarks,
            ].filter(Boolean).join(' ').toLowerCase();
            if (!haystack.includes(term)) return false;
        }
        return true;
    };

    // Count of currently active filters (for the Filters badge)
    const activeFilterCount = [
        classId,
        sectionId,
        studentId,
        startDate1 && endDate1 ? 'range' : '',
        statusFilter !== 'all' ? 'status' : '',
        keyFilter !== 'all' ? 'key' : '',
    ].filter(Boolean).length;

    const pad2 = (n) => String(n).padStart(2, '0');
    const toIso = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

    // Quick range selector ("This Week" / "This Month" / "Custom")
    const applyQuickRange = (range) => {
        setQuickRange(range);
        if (range === 'week') {
            const w = getWeekStartEnd(new Date());
            setStartDate1(w.start);
            setEndDate1(w.end);
        } else if (range === 'month') {
            const now = new Date();
            const first = new Date(now.getFullYear(), now.getMonth(), 1);
            const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            setStartDate1(toIso(first));
            setEndDate1(toIso(last));
        } else {
            setStartDate1('');
            setEndDate1('');
        }
    };

    // Reset all filters back to default
    const handleResetFilters = () => {
        setClassId('');
        setSectionId('');
        setStudentId('');
        setStartDate1('');
        setEndDate1('');
        setSectionList([]);
        setStudentList([]);
        setStatusFilter('all');
        setKeyFilter('all');
        setShowMaster(false);
        setQuickRange('custom');
        setTableSearch('');
        setTableSearchDebounced('');
    };

    const handleTableSearchChange = useCallback((e) => {
        const value = e.target.value;
        setTableSearch(value);
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = setTimeout(() => {
            setTableSearchDebounced(value);
        }, 250);
    }, []);

    const headerCellStyle = {
        backgroundColor: '#f4f6fa',
        color: '#46566b',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #e6eaf0',
    };

    // Checkbox + Class + Section + visible dynamic columns + Actions
    const visibleColumnCount = 3 + columnConfig.filter((c) => visibleCols[c.id]).length + 1;

    const visiblePaginatedActivityIds = useMemo(() => {
        const ids = [];
        // Server already returns only the current page of groups.
        activityList
            .forEach((group, groupIndex) => {
                const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
                const records = (group.activityRecordsId || [])
                    .filter(isActivityRecord)
                    .filter((a) => matchesActivityFilters(a, studentName));
                const studentKey = getStudentGroupKey(group, groupIndex);
                const activeKeyFilter = studentKeyFilters[studentKey];
                const displayRecords = activeKeyFilter
                    ? records.filter((rec) => {
                        const idx = getActivityKeyIndex(rec.key);
                        return activeKeyFilter === 'notSet'
                            ? idx === -1
                            : KEY_SEQUENCE[idx] === activeKeyFilter;
                    })
                    : records;
                displayRecords.forEach((activity) => {
                    if (activity?._id) ids.push(String(activity._id));
                });
            });
        return ids;
    }, [
        activityList,
        pg,
        rpg,
        statusFilter,
        keyFilter,
        tableSearchDebounced,
        studentKeyFilters,
    ]);

    const selectedIdSet = useMemo(
        () => new Set(selectedTableActivityIds),
        [selectedTableActivityIds]
    );

    const exportExcelData = useMemo(() => buildExportRows(activityList), [activityList]);

    const allVisibleActivitiesSelected =
        visiblePaginatedActivityIds.length > 0
        && visiblePaginatedActivityIds.every((id) => selectedIdSet.has(id));
    const someVisibleActivitiesSelected =
        visiblePaginatedActivityIds.some((id) => selectedIdSet.has(id));

    const toggleActivitySelection = (activityId) => {
        const id = String(activityId);
        setSelectedTableActivityIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };

    const toggleSelectAllVisibleActivities = () => {
        if (allVisibleActivitiesSelected) {
            setSelectedTableActivityIds((prev) =>
                prev.filter((id) => !visiblePaginatedActivityIds.includes(id))
            );
            return;
        }
        setSelectedTableActivityIds((prev) => [
            ...new Set([...prev, ...visiblePaginatedActivityIds]),
        ]);
    };

    const getActivityLabelsForIds = (ids) => {
        const idSet = new Set((ids || []).map(String));
        const labels = [];
        activityList.forEach((group) => {
            (group.activityRecordsId || []).forEach((record) => {
                if (!isActivityRecord(record) || !idSet.has(String(record._id))) return;
                const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
                const activityName = record.activityId?.activityName || 'Activity';
                const exerciseName = record.subActivityId?.subActivityName;
                const label = [studentName, activityName, exerciseName].filter(Boolean).join(' — ');
                labels.push(label || 'Activity');
            });
        });
        return labels;
    };

    const keyOptions = [
        { label: 'Presented(1)', value: 'P' },
        { label: 'Works with Assistance(2)', value: 'WA' },
        { label: 'Works Independently(3)', value: 'WI' },
        { label: 'Mastered(4)', value: 'M' }
    ];

    // Function to get color styling for key status
    const getKeyStatusStyle = (key) => {
        switch (key) {
            case 'P': // Presented
                return {
                    backgroundColor: '#2196F3', // Blue
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'WA': // Work with Assistance
                return {
                    backgroundColor: '#FF9800', // Orange
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'WI': // Work Independently
                return {
                    backgroundColor: '#9C27B0', // Purple
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            case 'M': // Mastered
                return {
                    backgroundColor: '#4CAF50', // Green
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block'
                };
            default:
                return {};
        }
    };

    // Function to get key status text
    const getKeyStatusText = (key) => {
        switch (key) {
            case 'P':
                return 'Presented';
            case 'WA':
                return 'Work with Assistance';
            case 'WI':
                return 'Work Independently';
            case 'M':
                return 'Mastered';
            default:
                return key || 'Not set';
        }
    };

    const openKeyUpdateDialog = (activity, currentKey, nextKey) => {
        setKeyUpdateDialog({
            open: true,
            activity,
            currentKey,
            nextKey,
            currentLabel: getKeyStatusText(currentKey),
            nextLabel: getKeyStatusText(nextKey),
            deselect: false,
        });
    };

    const openKeyDeselectDialog = (activity, currentKey) => {
        setKeyUpdateDialog({
            open: true,
            activity,
            currentKey,
            nextKey: '',
            currentLabel: getKeyStatusText(currentKey),
            nextLabel: getKeyStatusText(''),
            deselect: true,
        });
    };

    const handleKeyUpdateCancel = () => {
        setKeyUpdateDialog({
            open: false,
            activity: null,
            currentKey: '',
            nextKey: '',
            currentLabel: '',
            nextLabel: '',
            deselect: false,
        });
    };

    const patchActivityInList = (activityId, apiRecord) => {
        setActivityList((prev) => applyActivityRecordPatch(prev, activityId, apiRecord, !showMaster));
    };

    const handleKeyUpdateConfirm = async () => {
        const { activity, nextKey, deselect } = keyUpdateDialog;
        if (!activity?._id) return;
        if (!deselect && !nextKey) return;

        setUpdatingKeyId(activity._id);
        try {
            const response = await ActivityService.updateActivityStatus({ id: activity._id, key: nextKey });
            const clearedKey = deselect ? '' : nextKey;
            const apiRecord = response?.activityRecord
                ? { ...response.activityRecord, key: clearedKey }
                : { key: clearedKey };
            patchActivityInList(activity._id, apiRecord);
            handleKeyUpdateCancel();
            setMessageDialogContent({
                title: 'Success',
                message: response?.message || (deselect ? 'Activity status removed successfully.' : 'Activity key updated successfully.'),
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            const apiMessage = err.response?.data?.message ?? err.response?.data ?? err.message;
            setMessageDialogContent({
                title: 'Error',
                message: normalizeDialogMessage(apiMessage) || 'Failed to update activity key.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setUpdatingKeyId(null);
        }
    };

    const renderActivityTableSkeleton = () =>
        Array.from({ length: 6 }).map((_, index) => (
            <TableRow key={`activity-skeleton-${index}`} className={classes.groupHeaderRow}>
                <TableCell
                    colSpan={visibleColumnCount}
                    className={classes.groupHeaderCell}
                    style={{ cursor: 'default' }}
                >
                    <Box className={classes.groupHeaderInner}>
                        <Box display="flex" alignItems="center" gridGap={10}>
                            <Skeleton variant="circle" width={28} height={28} animation="wave" classes={{ root: classes.skeletonBar }} />
                            <Skeleton
                                variant="text"
                                width={120 + (index % 3) * 36}
                                height={24}
                                animation="wave"
                                classes={{ root: classes.skeletonBar }}
                            />
                            <Skeleton
                                variant="rect"
                                width={index % 2 === 0 ? 76 : 64}
                                height={20}
                                animation="wave"
                                style={{ borderRadius: 12 }}
                                classes={{ root: classes.skeletonBar }}
                            />
                        </Box>
                        <Skeleton variant="circle" width={20} height={20} animation="wave" classes={{ root: classes.skeletonBar }} />
                    </Box>
                </TableCell>
            </TableRow>
        ));

    const renderKeyStatusStepper = (activity) => {
        const isUpdating = updatingKeyId === activity._id;
        const currentKey = normalizeActivityKey(activity.key);
        const currentIndex = getActivityKeyIndex(activity.key);
        const canEditKeys = !isUpdating;

        if (isUpdating) {
            return <CircularProgress size={14} />;
        }

        return (
            <Box className={classes.keyStepRow}>
                {keyOptions.map((option) => {
                    const stepIndex = KEY_SEQUENCE.indexOf(option.value);
                    const color = KEY_CIRCLE_COLORS[option.value];
                    const meta = KEY_STEP_META[option.value];
                    const StepIcon = meta.Icon;
                    const optionKey = normalizeActivityKey(option.value);
                    const isCurrent = Boolean(currentKey) && optionKey === currentKey;
                    const isDone = currentIndex >= 0 && stepIndex < currentIndex;
                    const isComplete = isDone || isCurrent;
                    const isClickable = canEditKeys;

                    const iconWrapStyle = {
                        border: `2px solid ${KEY_INCOMPLETE_COLOR}`,
                        backgroundColor: '#fff',
                        color: KEY_INCOMPLETE_COLOR,
                    };
                    let labelColor = KEY_INCOMPLETE_LABEL;

                    if (isComplete) {
                        labelColor = color;
                        if (isDone) {
                            iconWrapStyle.backgroundColor = color;
                            iconWrapStyle.border = `2px solid ${color}`;
                            iconWrapStyle.color = '#fff';
                        } else {
                            iconWrapStyle.backgroundColor = '#fff';
                            iconWrapStyle.border = `2px solid ${color}`;
                            iconWrapStyle.color = color;
                        }
                    }

                    const itemClassName = [
                        classes.keyStepItem,
                        isDone && option.value === 'P' && classes.keyStepItemDoneP,
                        isClickable && classes.keyStepClickable,
                        !isClickable && classes.keyStepDisabled,
                    ].filter(Boolean).join(' ');

                    const handleStepClick = (e) => {
                        if (!isClickable) return;
                        e.stopPropagation();
                        if (isCurrent) {
                            openKeyDeselectDialog(activity, currentKey);
                        } else {
                            openKeyUpdateDialog(activity, currentKey, option.value);
                        }
                    };

                    const tooltipTitle = isClickable
                        ? isCurrent
                            ? `${meta.shortLabel} (current) — click to deselect`
                            : isDone
                                ? `${meta.shortLabel} — click to change back`
                                : `${meta.shortLabel} — click to update`
                        : isCurrent
                            ? `${meta.shortLabel} (current)`
                            : isDone
                                ? `${meta.shortLabel} (completed)`
                                : meta.shortLabel;

                    const stepContent = (
                        <Box
                            className={itemClassName}
                            onClick={handleStepClick}
                            onKeyDown={(e) => {
                                if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
                                    e.preventDefault();
                                    if (isCurrent) {
                                        openKeyDeselectDialog(activity, currentKey);
                                    } else {
                                        openKeyUpdateDialog(activity, currentKey, option.value);
                                    }
                                }
                            }}
                            role={isClickable ? 'button' : undefined}
                            tabIndex={isClickable ? 0 : -1}
                            aria-label={tooltipTitle}
                            aria-disabled={!isClickable}
                        >
                            <span className={classes.keyStepIconWrap} style={iconWrapStyle}>
                                <StepIcon style={{ fontSize: isDone && option.value === 'P' ? 16 : 15 }} />
                            </span>
                            <Typography
                                component="span"
                                className={classes.keyStepLabel}
                                style={{ color: labelColor }}
                            >
                                {meta.shortLabel}
                            </Typography>
                        </Box>
                    );

                    return (
                        <Tooltip key={option.value} title={tooltipTitle} arrow>
                            <span style={{ display: 'inline-flex' }}>{stepContent}</span>
                        </Tooltip>
                    );
                })}
            </Box>
        );
    };

    // Function to format date to D/M/Y format
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                // If dateString is already in YYYY-MM-DD format, parse it manually
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    const day = parts[2];
                    const month = parts[1];
                    const year = parts[0];
                    return `${day}/${month}/${year}`;
                }
                return dateString;
            }
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (error) {
            return dateString;
        }
    };

    // Function to check if activity should be highlighted (end date passed and not mastered)
    const shouldHighlightRow = (activity) => {
        if (!activity.endDate) return false;
        if (activity.key === 'M') return false; // Don't highlight if mastered
        
        try {
            const endDate = new Date(activity.endDate);
            const today = new Date();
            // Set time to midnight for accurate date comparison
            today.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);
            
            // Check if end date has passed
            return endDate < today;
        } catch (error) {
            return false;
        }
    };
    const getWeekStartEnd = (date) => {
        const startOfWeek = new Date(date);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
        const endOfWeek = new Date(date);
        endOfWeek.setDate(endOfWeek.getDate() + (5 - endOfWeek.getDay()));

        let startDay = startOfWeek.getDate();
        let startMonth = startOfWeek.getMonth() + 1;
        let startYear = startOfWeek.getFullYear();
        if (startDay < 10) {
            startDay = '0' + startDay;
        }

        if (startMonth < 10) {
            startMonth = `0${startMonth}`;
        }
        let format = startYear + "-" + startMonth + "-" + startDay;

        let endDay = endOfWeek.getDate();
        let endMonth = endOfWeek.getMonth() + 1;
        let endYear = endOfWeek.getFullYear();
        if (endDay < 10) {
            endDay = '0' + endDay;
        }

        if (endMonth < 10) {
            endMonth = `0${endMonth}`;
        }

        let format1 = endYear + "-" + endMonth + "-" + endDay;

        return { start: format, end: format1 };
    }
    const date = new Date();
    const week = getWeekStartEnd(date);
    const year = today.getFullYear();

    const [activity, setActivity] = useState({
        classId: '',
        sectionId: '',
        // date: new Date().toISOString().split("T")[0],
        // studentId: '',
        studentId: [],
        superActivityId: '',
        activityId: '',
        subActivityId: '',
        key: '',
        remarks: '',
        // planning: '',
        isEdit: false,
        endDate: '',
        date: '',
    });

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
        refreshActivityTable(undefined, undefined, { page: newpage });
    }
    const verifyeetnt = () => {};
    const formRefs = {
        date: React.useRef(),
        endDate: React.useRef(),
        classId: React.useRef(),
        studentId: React.useRef(),
    };
    const filterTreeNode = (node) => {
        if (searchTerm === "") return true;
        const term = searchTerm.toLowerCase();

        // Check if current node matches
        if (node.superActivityName?.toLowerCase().includes(term) ||
            node.activityName?.toLowerCase().includes(term) ||
            node.subActivityName?.toLowerCase().includes(term)) {
            return true;
        }

        // Check children (activities)
        if (node.activities?.some(activity =>
            activity.activityName?.toLowerCase().includes(term) ||
            activity.subActivities?.some(sub =>
                sub.subActivityName?.toLowerCase().includes(term)
            )
        )) {
            return true;
        }

        // Check sub-activities
        if (node.subActivities?.some(sub =>
            sub.subActivityName?.toLowerCase().includes(term)
        )) {
            return true;
        }

        return false;
    };
    const handleChangeRowsPerPage = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        setrpg(newLimit);
        setpg(0);
        refreshActivityTable(undefined, undefined, { page: 0, limit: newLimit });
    }
    const getAllSuperActivityTabelMultiple = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const schooleId =
            userDetails?.schooleId?._id ||
            userDetails?.schooleId ||
            userDetails?.schoolId?._id ||
            userDetails?.schoolId;
        const getsupActList = { classId: event.target.value, schooleId };

        SuperActivityService.getAllSuperActivityTabelMultiple(getsupActList).then((res) => {

            setSelectedActivities(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    //   };

    //   const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    //   };
    // classId: Yup.string().required('Class Name is required'),

    const validationSchema = Yup.object().shape({
        classId: Yup.string().required('Class Name is required'),
       // date: Yup.string(new Date().toISOString().split("T")[0]).required('Date is required'),
        studentId: Yup.array(),
        activityId: Yup.string(),
        subActivityId: Yup.string().nullable(),
        key: Yup.string(),
        // academicYear:Yup.string(),
        remarks: Yup.string(),
        planning: Yup.string(),
        //date: Yup.string().nullable(),
        isEdit: Yup.boolean(),
        _id: Yup.string().nullable(),
        date: Yup.string().required('date is required'),
        endDate: Yup.string().required('date is required'),
        isEventForAllStudent: Yup.boolean(),
    });
    useEffect(() => {
        getAddClassList();
        return () => {
            fetchRequestIdRef.current += 1;
            if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
            if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        };
    }, []);
    // useEffect(() => {
    //     //getActivityList();
    //     onSubmit();
    //     // getStudentActivityList();

    //     getAddClassList();
    //     //  getSuperActivityList();
    //     return () => {
    //         setSubActivityList([]);
    //         setActivityIdList([]);
    //         setActivityList([]);
    //         setStudentList([]);
    //         setAddSuperActivityList([]);
    //         setStudentReportList([]);
    //     }
    // }, []);
    
    // Function to check for duplicate activities
    // const checkDuplicateActivities = async (studentIds, activityRelationships, isEventForAllStudent, classId) => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     const duplicates = [];
        
    //     // Get all students to check (handle "For All Class Students" case)
    //     let studentsToCheck = studentIds;
    //     if (isEventForAllStudent && classId) {
    //         // If "For All Class Students" is checked, fetch all students in the class
    //         try {
    //             const allStudents = await StudentService.getAllStudentById(userDetails.schooleId, { classId });
    //             studentsToCheck = allStudents.map(student => student._id);
    //         } catch (error) {
    //             console.error('Error fetching all students:', error);
    //             // Fallback to selected students if fetch fails
    //             studentsToCheck = studentIds;
    //         }
    //     }

    //     // Check each student and activity combination
    //     for (const studentId of studentsToCheck) {
    //         for (const [key, relationship] of Object.entries(activityRelationships)) {
    //             const checkData = {
    //                 schooleId: userDetails.schooleId,
    //                 classId: classId,
    //                 studentId: studentId,
    //                 isFuturePlanning: false
    //             };

    //             try {
    //                 const existingActivities = await ActivityService.findActivityList(checkData);
                    
    //                 // Check if any activity record matches
    //                 if (existingActivities && existingActivities.length > 0) {
    //                     for (const activityGroup of existingActivities) {
    //                         if (activityGroup.activityRecordsId && activityGroup.activityRecordsId.length > 0) {
    //                             const matchingRecord = activityGroup.activityRecordsId.find(record => {
    //                                 const activityMatch = record.activityId?._id === relationship.activityId;
    //                                 const subActivityMatch = relationship.subActivityId 
    //                                     ? record.subActivityId?._id === relationship.subActivityId
    //                                     : !record.subActivityId; // If no subActivity in relationship, check for null in record
    //                                 return activityMatch && subActivityMatch;
    //                             });
                                
    //                             if (matchingRecord) {
    //                                 const studentName = activityGroup.studentId 
    //                                     ? `${activityGroup.studentId.firstName} ${activityGroup.studentId.lastName}`
    //                                     : 'Unknown Student';
    //                                 const activityName = matchingRecord.activityId?.activityName || 'Unknown Activity';
    //                                 const subActivityName = matchingRecord.subActivityId?.subActivityName || '';
    //                                 duplicates.push({
    //                                     studentId,
    //                                     studentName,
    //                                     activityName,
    //                                     subActivityName: subActivityName || 'N/A'
    //                                 });
    //                             }
    //                         }
    //                     }
    //                 }
    //             } catch (error) {
    //                 console.error('Error checking duplicates:', error);
    //             }
    //         }
    //     }
        
    //     return duplicates;
    // };

    // Function to fetch and group unmastered activities by studentId
    const fetchAndGroupUnmasteredActivities = async (classId, schooleId) => {
        try {
            if (!classId || !schooleId) {
                setGroupedUnmasteredActivities({});
                return;
            }

            // Get all students in the class
        

            const checkData = {
                schooleId: schooleId,
                classId: classId,
                sectionId: sectionId || undefined,
            };

            const response = await ActivityService.getUnmasteredActivities(checkData);
            const responseData = response.data || response;
            
            if (responseData && responseData.success && responseData.activities) {
                // Group activities by studentId._id
                const grouped = {};
                responseData.activities.forEach(activity => {
                    const studentIdKey = activity.studentId?._id;
                    if (studentIdKey) {
                        if (!grouped[studentIdKey]) {
                            grouped[studentIdKey] = [];
                        }
                        grouped[studentIdKey].push(activity);
                    }
                });
                setGroupedUnmasteredActivities(grouped);
            } else {
                setGroupedUnmasteredActivities({});
            }
        } catch (error) {
            console.error('Error fetching unmastered activities:', error);
            setGroupedUnmasteredActivities({});
        }
    };

    // Function to check unmastered activities before submitting
    const checkUnmasteredActivitiesBeforeSubmit = async (studentIds, classId, isEventForAllStudent, schooleId) => {
        try {
            let studentsToCheck = studentIds || [];
            // If "For All Class Students" is selected, fetch all students in the class
            if (isEventForAllStudent && classId) {
                try {
                    const allStudents = await StudentService.getAllStudentById(schooleId, { classId });
                    studentsToCheck = allStudents.map(student => student._id);
                } catch (error) {
                    console.error('Error fetching all students:', error);
                    studentsToCheck = studentIds || [];
                }
            }

            if (!studentsToCheck || studentsToCheck.length === 0) {
                return { hasUnmastered: false, activities: [], count: 0 };
            }

            const checkData = {
                studentId: studentsToCheck,
                schooleId: schooleId,
                classId: classId,
                sectionId: sectionId || undefined,
            };

            const response = await ActivityService.getUnmasteredActivities(checkData);
            const responseData = response.data || response;
            
            if (responseData && responseData.success && responseData.count > 0) {
                return {
                    hasUnmastered: true,
                    activities: responseData.activities || [],
                    count: responseData.count || 0
                };
            }

            return {
                hasUnmastered: false,
                activities: [],
                count: 0
            };
        } catch (error) {
            console.error('Error checking unmastered activities:', error);
            return { hasUnmastered: false, activities: [], count: 0 };
        }
    };

    // Function to submit activity after user confirms
    const resetActivityForm = () => {
        setActivity({
            classId: classId || '',
            sectionId: sectionId || '',
            studentId: [],
            superActivityId: '',
            activityId: '',
            subActivityId: '',
            key: '',
            remarks: '',
            isEdit: false,
            endDate: '',
            date: '',
            sfd: '',
        });
    };

    const refreshExistingActivityKeys = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
        if (!schooleId || !classId) {
            setExistingKeySet(new Set());
            setExistingKeyStudents({});
            return Promise.resolve();
        }
        return ActivityService.getExistingActivityKeys({
            schooleId,
            classId,
            sectionId: sectionId || null,
            studentId: [],
            isEventForAllStudent: false,
        }).then((r) => {
            const data = r?.data || r;
            const keys = Array.isArray(data?.keys) ? data.keys : [];
            setExistingKeySet(new Set(keys));
            setExistingKeyStudents(data?.byKey || {});
        }).catch(() => {
            setExistingKeySet(new Set());
            setExistingKeyStudents({});
        });
    };

    const refreshActivityTable = useCallback((startDate, endDate, opts = {}) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate = startDate1 || startDate || "";
        const newendDate = endDate1 || endDate || "";

        // Server-side pagination: request only the current page of student
        // groups. Overrides (page/limit) let handlers request an exact page
        // without waiting for the pg/rpg state to commit.
        const page = opts.page !== undefined ? opts.page : pgRef.current;
        const limit = opts.limit !== undefined ? opts.limit : rpgRef.current;

        const keys = {
            schooleId: userDetails.schooleId,
            isFuturePlanning: false,
            studentId,
            classId,
            sectionId: sectionId || undefined,
            status: true,
            page,
            limit,
        };
        if (newstartDate && newendDate) {
            keys.startDate1 = newstartDate;
            keys.endDate1 = newendDate;
        }
        if (!showMaster) {
            keys.showMaster = false;
        }

        const requestId = fetchRequestIdRef.current + 1;
        fetchRequestIdRef.current = requestId;
        setActivityTableLoading(true);

        return ActivityService.findActivityList(keys)
            .then((res) => {
                if (requestId !== fetchRequestIdRef.current) return [];
                // Paginated response is { data, total, ... }; fall back to a
                // plain array for safety / backward compatibility.
                const list = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
                const total = Array.isArray(res) ? list.length : (Number(res?.total) || 0);
                setActivityList(list);
                setActivityTotal(total);
                setObservationExpanded({});
                setImagesExpanded({});
                collapseAllStudentActivityRows();
                return list;
            })
            .catch(() => [])
            .finally(() => {
                if (requestId === fetchRequestIdRef.current) {
                    setActivityTableLoading(false);
                }
            });
    }, [classId, sectionId, studentId, startDate1, endDate1, showMaster]);

    const submitActivityAfterConfirmation = (values, resetForm) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        let currentYear = new Date().getFullYear();
        let nextYear = new Date().getFullYear() + 1;
        values['academicYear'] = currentYear + "-" + nextYear;
        values.subActivityId = (values.subActivityId && values.subActivityId.trim() !== '') ? values.subActivityId : null;
        values.date = values.date ? values.date : new Date().toISOString().split("T")[0];
        values.isEventForAllStudent = values.isEventForAllStudent || false;
        values.schooleId = userDetails.schooleId;
        // Section is optional: only apply the section explicitly chosen in the
        // dialog (do not fall back to the page-level section filter).
        values.sectionId = values.sectionId || null;
        values.authorizedPerson = userDetails.email;
        values.teacherId = userDetails.teacherId || null;
        values.isFuturePlanning = false;
        if (!values.activityRelationships || Object.keys(values.activityRelationships).length === 0) {
            values.activityRelationships = selectedActivityMap;
        }
        
        setAddActivityLoading(true);
        ActivityService.creteMultipleActivity(values).then(async () => {
            setpg(0);
            await refreshActivityTable(undefined, undefined, { page: 0 });
            await refreshExistingActivityKeys();
            setAddActivityLoading(false);
            resetForm();
            resetActivityForm();
            setCheckedActivities([]);
            setSelectedActivityMap({});
            setCheckedSubActivities([]);
            handleClose();
            setMessageDialogContent({
                title: 'Success',
                message: 'Activity Added Successfully.',
                type: 'success'
            });
            setOpenMessageDialog(true);
        }).catch((err) => {
            setAddActivityLoading(false);
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to add activity.',
                type: 'error'
            });
            setOpenMessageDialog(true);
        });
    };

    const formik = useFormik({
        initialValues: activity,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.authorizedPerson = userDetails.email
            values.isFuturePlanning = false
            // Section is optional: use only the section explicitly chosen in the
            // dialog. Do NOT fall back to the page-level section filter, otherwise
            // adding for a class with no section wrongly triggers a section error.
            values.sectionId = values.sectionId || null;
            values.activityRelationships = selectedActivityMap;

            const recordId = values._id || activity._id;

            if (recordId) {
                const payload = { ...values, _id: recordId };
                try {
                    await ActivityService.upadeActivity(payload);
                    setpg(0);
                    await refreshActivityTable(undefined, undefined, { page: 0 });
                    await refreshExistingActivityKeys();
                    handleClose();
                    resetForm();
                    resetActivityForm();
                    setMessageDialogContent({
                        title: 'Success',
                        message: 'Activity Updated Successfully.',
                        type: 'success'
                    });
                    setOpenMessageDialog(true);
                } catch (err) {
                    setMessageDialogContent({
                        title: 'Error',
                        message: err.response?.data?.message || 'Failed to update activity.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                }
            }
            else if (values.isEdit) {
                if (!values.activityId || !values.superActivityId) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select area of work and activity before adding more.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }
                if (!values.studentId || values.studentId.length === 0) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one student.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                values.activityRelationships = {
                    [`add-more-${values.activityId}-${values.subActivityId || 'none'}`]: {
                        superActivityId: values.superActivityId,
                        activityId: values.activityId,
                        subActivityId: values.subActivityId || null,
                    },
                };

                try {
                    const dupRes = await ActivityService.checkDuplicateActivities({
                        schooleId: values.schooleId,
                        classId: values.classId,
                        sectionId: values.sectionId || sectionId || null,
                        studentId: values.studentId,
                        isEventForAllStudent: false,
                        activityRelationships: values.activityRelationships,
                    });
                    const payload = dupRes?.data || dupRes;
                    if (payload?.hasDuplicates && Array.isArray(payload.duplicates) && payload.duplicates.length > 0) {
                        const names = Array.from(new Set(payload.duplicates.map((d) => d.studentName).filter(Boolean)));
                        const list = names.slice(0, 15).map((n) => `• ${n}`).join("\n");
                        const more = names.length > 15 ? `\n...and ${names.length - 15} more` : "";
                        setMessageDialogContent({
                            title: 'Duplicate Activity',
                            message: `This activity already exists for the following student(s):\n${list}${more}\n\nPlease select a different activity or edit the existing one.`,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                } catch (e) {
                    const preCheckMsg = e?.response?.data?.message;
                    if (preCheckMsg) {
                        setMessageDialogContent({
                            title: 'Error',
                            message: preCheckMsg,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                }

                submitActivityAfterConfirmation(values, resetForm);
            }
            else {
                // Validation checks
                if (!values.isEventForAllStudent && (!values.studentId || values.studentId.length === 0)) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one student.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                if (values.isEventForAllStudent) {
                    if (!values.classId) {
                        setMessageDialogContent({
                            title: 'Validation Error',
                            message: 'Please select a class first.',
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                    const effectiveSectionId = values.sectionId || null;
                    if (studentList.length === 0) {
                        setMessageDialogContent({
                            title: 'No Students Found',
                            message: effectiveSectionId
                                ? 'No students found in the selected section. Please add students to this section or choose a different section.'
                                : 'No students found in the selected class. Please add students to this class or choose a different class.',
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                }

                if (!selectedActivityMap || Object.keys(selectedActivityMap).length === 0) {
                    setMessageDialogContent({
                        title: 'Validation Error',
                        message: 'Please select at least one activity.',
                        type: 'error'
                    });
                    setOpenMessageDialog(true);
                    return;
                }

                // Pre-check duplicates BEFORE saving (single student / multiple / entire class)
                try {
                    const dupRes = await ActivityService.checkDuplicateActivities({
                        schooleId: values.schooleId,
                        classId: values.classId,
                        sectionId: values.sectionId || null,
                        studentId: values.studentId,
                        isEventForAllStudent: values.isEventForAllStudent || false,
                        activityRelationships: selectedActivityMap,
                    });
                    const payload = dupRes?.data || dupRes;
                    if (payload?.hasDuplicates && Array.isArray(payload.duplicates) && payload.duplicates.length > 0) {
                        const names = Array.from(new Set(payload.duplicates.map((d) => d.studentName).filter(Boolean)));
                        const list = names.slice(0, 15).map((n) => `• ${n}`).join("\n");
                        const more = names.length > 15 ? `\n...and ${names.length - 15} more` : "";
                        setMessageDialogContent({
                            title: 'Duplicate Activity',
                            message: `This activity already exists for the following student(s):\n${list}${more}\n\nPlease select a different activity or edit the existing one.`,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                } catch (e) {
                    const preCheckMsg = e?.response?.data?.message;
                    if (preCheckMsg) {
                        setMessageDialogContent({
                            title: 'Error',
                            message: preCheckMsg,
                            type: 'error'
                        });
                        setOpenMessageDialog(true);
                        return;
                    }
                    console.error("Duplicate pre-check failed:", e);
                }

                // Proceed with submission
                submitActivityAfterConfirmation(values, resetForm);
            }

        },
    });
    const renderTree = (node) => {
        // Don't render if it doesn't match the search
        if (!filterTreeNode(node)) return null;
        const superActivitId = node._id;
        // Super Activity node
        if (node.superActivityName) {
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    // label={node.superActivityName}
                    label={
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <LanguageIcon style={{ marginRight: 8, color: "#4caf50" }} />
                            {node.superActivityName}
                        </div>
                    }
                    onClick={(e) => e.stopPropagation()}
                >
                    {Array.isArray(node.activities) && node.activities.map(renderTree)}
                </TreeItem>
            );
        }
        // Activity node
        if (node.activityName) {
            const hasSubActivities = Array.isArray(node.subActivities) && node.subActivities.length > 0;
            const subActivityIds = hasSubActivities ? node.subActivities.map(sub => sub._id) : [];
            const existingKey = `${String(node._id)}|`;
            const isAlreadyAdded = existingKeySet.has(existingKey);
            if (showOnlyExisting && !isAlreadyAdded && !hasSubActivities) return null;
            const hasNotes = Boolean(node.notes && String(node.notes).trim() !== "");

            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                opacity: isAlreadyAdded ? 0.7 : 1,
                                background: isAlreadyAdded ? "rgba(220, 38, 38, 0.08)" : "transparent",
                                borderRadius: 8,
                                paddingRight: 6,
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        setCheckedActivities((prev) =>
                                            prev.includes(node._id) ? prev : [...prev, node._id]
                                        );
                                        if (hasSubActivities) {
                                            setCheckedSubActivities((prev) => {
                                                const next = [...prev];
                                                subActivityIds.forEach((id) => {
                                                    if (!next.some((p) => String(p) === String(id))) {
                                                        next.push(id);
                                                    }
                                                });
                                                return next;
                                            });
                                            setSelectedActivityMap((prev) => {
                                                const next = { ...prev };
                                                node.subActivities.forEach((sub) => {
                                                    next[sub._id] = {
                                                        subActivityId: sub._id,
                                                        activityId: node._id,
                                                        superActivityId: node.superActivityId,
                                                        isChild: true,
                                                    };
                                                });
                                                return next;
                                            });
                                        } else {
                                            setSelectedActivityMap((prev) => ({
                                                ...prev,
                                                [node._id]: {
                                                    activityId: node._id,
                                                    superActivityId: node.superActivityId,
                                                    isChild: false,
                                                },
                                            }));
                                        }
                                    } else {
                                        setCheckedActivities((prev) => prev.filter((id) => id !== node._id));
                                        if (hasSubActivities) {
                                            setCheckedSubActivities((prev) =>
                                                prev.filter(
                                                    (id) =>
                                                        !subActivityIds.some((sid) => String(sid) === String(id))
                                                )
                                            );
                                            setSelectedActivityMap((prev) => {
                                                const newMap = { ...prev };
                                                subActivityIds.forEach((id) => delete newMap[id]);
                                                return newMap;
                                            });
                                        } else {
                                            setSelectedActivityMap((prev) => {
                                                const newMap = { ...prev };
                                                delete newMap[node._id];
                                                return newMap;
                                            });
                                        }
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.activityName}</span>
                            {hasNotes && (
                                <Tooltip
                                    title="Click or tap to read the full note"
                                    placement="bottom"
                                >
                                    <IconButton
                                        size="small"
                                        aria-label="View activity note"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setActivityNoteDialog({
                                                open: true,
                                                title: String(node.activityName || "Activity"),
                                                text: String(node.notes || ""),
                                            });
                                        }}
                                        style={{ marginLeft: 2, padding: 6 }}
                                    >
                                        <InfoOutlinedIcon style={{ fontSize: 18, color: "#0f3b62" }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {isAlreadyAdded && (
                                <Button
                                    size="small"
                                    style={{ marginLeft: 8, fontSize: 12, color: "#dc2626", fontWeight: 700, textTransform: "none" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const students = existingKeyStudents?.[existingKey] || [];
                                        const unique = Array.from(new Set(students.filter(Boolean)));
                                        const shown = unique.slice(0, 30);
                                        const list = shown.map((n) => `• ${n}`).join("\n");
                                        const more = unique.length > shown.length ? `\n...and ${unique.length - shown.length} more` : "";
                                        setMessageDialogContent({
                                            title: "Already added",
                                            message: `Already added for ${unique.length} student(s):\n${list}${more}`,
                                            type: "info",
                                        });
                                        setOpenMessageDialog(true);
                                    }}
                                >
                                    (Already added: {(existingKeyStudents?.[existingKey] || []).length})
                                </Button>
                            )}
                        </div>
                    }
                >
                    {hasSubActivities && node.subActivities.map(sub =>
                        renderTree({ ...sub, parentActivityId: node._id, superActivityId: node.superActivityId, isChild: true })
                    )}
                </TreeItem>
            );
        }
        // SubActivity node
        if (node.subActivityName) {
            const existingKey = `${String(node.parentActivityId)}|${String(node._id)}`;
            const isAlreadyAdded = existingKeySet.has(existingKey);
            if (showOnlyExisting && !isAlreadyAdded) return null;
            const hasNotes = Boolean(node.notes && String(node.notes).trim() !== "");
            return (
                <TreeItem
                    key={node._id}
                    nodeId={node._id}
                    label={
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                opacity: isAlreadyAdded ? 0.7 : 1,
                                background: isAlreadyAdded ? "rgba(220, 38, 38, 0.08)" : "transparent",
                                borderRadius: 8,
                                paddingRight: 6,
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                size="small"
                                color="primary"
                                checked={checkedSubActivities.includes(node._id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    const checked = e.target.checked;
                                    if (checked) {
                                        // Check sub-activity
                                        setCheckedSubActivities(prev => [...prev, node._id]);
                                        // Check parent activity if not already checked
                                        if (!checkedActivities.includes(node.parentActivityId)) {
                                            setCheckedActivities(prev => [...prev, node.parentActivityId]);
                                        }
                                        // Store the relationship
                                        setSelectedActivityMap(prev => ({
                                            ...prev,
                                            [node._id]: {
                                                subActivityId: node._id,
                                                activityId: node.parentActivityId,
                                                superActivityId: node.superActivityId,
                                                isChild: true
                                            }
                                        }));
                                    } else {
                                        // Just uncheck the sub-activity
                                        setCheckedSubActivities(prev => prev.filter(id => id !== node._id));
                                        // Remove the relationship
                                        setSelectedActivityMap(prev => {
                                            const newMap = { ...prev };
                                            delete newMap[node._id];
                                            return newMap;
                                        });
                                    }
                                }}
                            />
                            <span onClick={(e) => e.stopPropagation()}>{node.subActivityName}</span>
                            {hasNotes && (
                                <Tooltip
                                    title="Click or tap to read the full note"
                                    placement="bottom"
                                >
                                    <IconButton
                                        size="small"
                                        aria-label="View exercise note"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setActivityNoteDialog({
                                                open: true,
                                                title: String(node.subActivityName || "Exercise"),
                                                text: String(node.notes || ""),
                                            });
                                        }}
                                        style={{ marginLeft: 2, padding: 6 }}
                                    >
                                        <InfoOutlinedIcon style={{ fontSize: 18, color: "#0f3b62" }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {isAlreadyAdded && (
                                <Button
                                    size="small"
                                    style={{ marginLeft: 8, fontSize: 12, color: "#dc2626", fontWeight: 700, textTransform: "none" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const students = existingKeyStudents?.[existingKey] || [];
                                        const unique = Array.from(new Set(students.filter(Boolean)));
                                        const shown = unique.slice(0, 30);
                                        const list = shown.map((n) => `• ${n}`).join("\n");
                                        const more = unique.length > shown.length ? `\n...and ${unique.length - shown.length} more` : "";
                                        setMessageDialogContent({
                                            title: "Already added",
                                            message: `Already added for ${unique.length} student(s):\n${list}${more}`,
                                            type: "info",
                                        });
                                        setOpenMessageDialog(true);
                                    }}
                                >
                                    (Already added: {(existingKeyStudents?.[existingKey] || []).length})
                                </Button>
                            )}
                        </div>
                    }
                >
                </TreeItem>
            );
        }
        return null;
    };

    const groupByStudentId = (data) => {
        return data.reduce((acc, item) => {
            const studentId = item.studentId ? item.studentId._id : "";

            if (!acc[studentId]) {
                acc[studentId] = {
                    studentDetails: {
                        _id: studentId,
                        firstName: item.studentId.firstName,
                        lastName: item.studentId.lastName,
                    },
                    activities: [],
                };
            }
            acc[studentId].activities.push(item);
            return acc;
        }, {});
    };
    const getSuperActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityById(userDetails.schooleId, getsupActList).then((res) => {

            setAddSuperActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const loadDialogSectionList = (classId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setDialogSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === 'TEACHER' && userDetails.sectionId) {
                //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
                // }
                setDialogSectionList(list);
            })
            .catch(() => setDialogSectionList([]));
    };

    const handleOpen = (isAdd) => {
        setOpen(true);
        if (isAdd) {
            const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
            // Section is optional when adding: teachers stay locked to their own
            // section, everyone else starts with no section (add for the whole
            // class) and can optionally pick one in the dialog. We intentionally
            // do NOT inherit the page-level section filter here.
            const initialSectionId = (userDetails.role === 'TEACHER' && userDetails.sectionId)
                ? userDetails.sectionId
                : '';
            setActivity({
                classId: classId || '',
                sectionId: initialSectionId,
                // date: new Date().toISOString().split("T")[0],
                // studentId: '',
                studentId: [],
                superActivityId: '',
                activityId: '',
                subActivityId: '',
                key: '',
                remarks: '',
                // planning: '',
                isEdit: false,
                endDate: '',
                sfd: '',
            });
            loadDialogSectionList(classId || '');
            if (classId) {
                // Load activity tree for the class so activities show when section/student are selected (without waiting for student)
                getAllSuperActivityTabelMultiple({ target: { value: classId } });
                getStudentList({ target: { value: classId } }, null, initialSectionId || '');
            } else {
                setStudentList([]);
            }
            // Clear activity selection state
            setCheckedActivities([]);
            setSelectedActivityMap({});
            setCheckedSubActivities([]);
            // Clear unmastered activities
            setGroupedUnmasteredActivities({});
            setFilteredUnmasteredActivities([]);
        }
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
        // Clear activity selection state when closing the dialog
        setCheckedActivities([]);
        setSelectedActivityMap({});
        setCheckedSubActivities([]);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const getSectionListByClass = (classId, defaultSectionId, onLoaded) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        if (!classId) {
            setSectionList([]);
            setSectionId('');
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                let list = Array.isArray(res) ? res : [];
                // if (userDetails.role === 'TEACHER' && userDetails.sectionId) {
                //     list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
                // }
                setSectionList(list);
                if (list.length === 0) {
                    // Selected class has no sections, so there is no section to filter by
                    setSectionId(null);
                } else if (defaultSectionId) {
                    setSectionId(defaultSectionId);
                }
                if (typeof onLoaded === 'function') {
                    onLoaded();
                }
            })
            .catch(() => {
                setSectionList([]);
                setSectionId(null);
                if (typeof onLoaded === 'function') {
                    onLoaded();
                }
            });
    };

    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schoolId = userDetails?.schooleId?._id || userDetails?.schooleId || userDetails?.schoolId?._id || userDetails?.schoolId;
        if (!schoolId) return;
        AddClassService.getAllAddClass(schoolId).then((res) => {
            const list = Array.isArray(res) ? res : [];
            // For TEACHER: only show their assigned class so class name and section show by default
            // const filteredList = userDetails.role === "TEACHER" && userDetails.classId
            //     ? list.filter((c) => String(c._id) === String(userDetails.classId))
            //     : list;
            setAddClassList(list);

            // By default show teacher's class name and section when they have classId (and optionally sectionId)
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                const defaultSectionId = userDetails.sectionId ? String(userDetails.sectionId) : '';
                if (defaultSectionId) {
                    setSectionId(defaultSectionId);
                }
                const classIdForStudents = userDetails.classId;
                getSectionListByClass(userDetails.classId, defaultSectionId || undefined, () => {
                    // After section list (and default section) are set, load students so section filter applies on first load
                    getStudentList({ target: { value: classIdForStudents } }, null, defaultSectionId || undefined);
                });
            } else {
                setClassId("");
                setSectionId("");
                setSectionList([]);
            }
        }).catch((err) => {
            setAddClassList([]);
        });
    };
    const onSubmit = useCallback(
        (startDate, endDate) => refreshActivityTable(startDate, endDate),
        [refreshActivityTable]
    );

    const handlePrintFilteredData = async () => {
        if (!classId) {
            setMessageDialogContent({
                title: 'Validation Error',
                message: 'Please select a class before printing.',
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        setPrinting(true);
        try {
            const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
            const keys = {
                schooleId: userDetails.schooleId,
                isFuturePlanning: false,
                studentId,
                classId,
                sectionId: sectionId || undefined,
                status: true,
                page: 0,
                limit: Math.max(activityTotal || 0, rpg, 1),
            };
            if (startDate1 && endDate1) {
                keys.startDate1 = startDate1;
                keys.endDate1 = endDate1;
            }
            if (!showMaster) {
                keys.showMaster = false;
            }

            const res = await ActivityService.findActivityList(keys);
            const groups = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
            const rows = buildPrintRowsFromGroups(groups, {
                matchesActivityFilters,
                studentKeyFilters,
                getStudentGroupKey,
            });

            if (rows.length === 0) {
                setMessageDialogContent({
                    title: 'No data',
                    message: 'No activities match the current filters to print.',
                    type: 'info',
                });
                setOpenMessageDialog(true);
                return;
            }

            const classLabel = addClassList.find((c) => String(c._id) === String(classId))?.className || '—';
            const sectionLabel = sectionId
                ? (sectionList.find((s) => String(s._id) === String(sectionId))?.sectionName || '—')
                : 'All Sections';
            const studentLabel = studentId
                ? (studentList.find((s) => String(s._id) === String(studentId))?.studentName || '—')
                : 'All Students';
            const dateLabel = startDate1 && endDate1 ? `${startDate1} to ${endDate1}` : 'All dates';
            const statusLabel = statusFilter === 'all'
                ? 'All Status'
                : statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1);
            const keyLabel = keyFilter === 'all'
                ? 'All Keys'
                : (KEY_DISPLAY_LABELS[keyFilter] || keyFilter);
            const searchLabel = tableSearchDebounced.trim() || '—';

            const html = buildActivityPrintHtml({
                title: 'Activity Planner Report',
                subtitle: 'Filtered activity records',
                filterLines: [
                    `Class: ${classLabel}`,
                    `Section: ${sectionLabel}`,
                    `Student: ${studentLabel}`,
                    `Date range: ${dateLabel}`,
                    `Status: ${statusLabel}`,
                    `Key: ${keyLabel}`,
                    `Search: ${searchLabel}`,
                    `Records: ${rows.length}`,
                ],
                rows,
                generatedAt: new Date().toLocaleString(),
            });

            const printWindow = window.open('', '_blank');
            if (!printWindow) {
                setMessageDialogContent({
                    title: 'Popup blocked',
                    message: 'Please allow popups to print the report.',
                    type: 'error',
                });
                setOpenMessageDialog(true);
                return;
            }
            printWindow.document.open();
            printWindow.document.write(html);
            printWindow.document.close();
        } catch (err) {
            setMessageDialogContent({
                title: 'Error',
                message: err?.response?.data?.message || 'Failed to prepare print view.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setPrinting(false);
        }
    };

    // Auto-load when filters change (debounced to avoid API storms)
    useEffect(() => {
        if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
        filterDebounceRef.current = setTimeout(() => {
            // Filters changed -> always jump back to the first server page.
            setpg(0);
            refreshActivityTable(startDate1, endDate1, { page: 0 });
        }, 300);
        return () => {
            if (filterDebounceRef.current) clearTimeout(filterDebounceRef.current);
        };
    }, [classId, sectionId, studentId, startDate1, endDate1, showMaster, refreshActivityTable]);

    const getStudentReportList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const newstartDate1 = startDate1 ? startDate1 : "";
        const newendDate1 = endDate1 ? endDate1 : "";
        if (studentId === '') {
            setMessageDialogContent({
                title: 'Validation Error',
                message: 'Please Select Student',
                type: 'error'
            });
            setOpenMessageDialog(true);
            return;
        }
        const getstudentId = { "studentId": studentId, "startDate1": newstartDate1, "endDate1": newendDate1 };

        SubActivityService.getStudentReport(getstudentId).then((res) => {
            // const blob = new Blob(res.pdfBuffer);
            const buffer = Buffer.from(res.pdfBuffer);
            const blob = new Blob([buffer]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "studentreport.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            // const blob = new Blob([res.pdfBuffer]);
            // saveAs(blob, 'filename.pdf');
            // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
            // setStudentReportList(res);
        }).catch((err) => {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'An error occurred',
                type: 'error'
            });
            setOpenMessageDialog(true);
        });
    };
    
    const getSubActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const activityId = event?.target?.value;
        if (!activityId) {
            setSubActivityList([]);
            if (obj) {
                setActivity(obj);
            }
            return;
        }
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: obj?.classId || formik.values.classId,
            activityId,
        };
        SubActivityService.getAllSubActivityByActivityId(getsubActList).then((res) => {
            let list = Array.isArray(res) ? res : [];
            const applyList = (finalList) => {
                setSubActivityList(finalList);
                if (obj) {
                    setActivity(obj);
                }
            };
            if (list.length === 0 && obj?.subActivityId && getsubActList.classId) {
                SubActivityService.getAllSubActivityByActivityId({
                    schooleId: getsubActList.schooleId,
                    activityId: getsubActList.activityId,
                })
                    .then((fallback) => applyList(Array.isArray(fallback) ? fallback : []))
                    .catch(() => applyList([]));
                return;
            }
            applyList(list);
        }).catch(() => {
            setSubActivityList([]);
            if (obj) {
                setActivity(obj);
            }
        });
    }
    
    const getActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const superActivityId = event?.target?.value;
        if (!superActivityId) {
            setAddActivityList([]);
            if (obj) {
                setActivity(obj);
            }
            return;
        }
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: obj?.classId || formik.values.classId,
            superActivityId,
        };

        ActivityTabelService.getAllActivityTabeBySuperActivityId(getsubActList).then((res) => {
            setAddActivityList(Array.isArray(res) ? res : []);
            if (obj) {
                setActivity(obj);
            }
        }).catch(() => {
            setAddActivityList([]);
            if (obj) {
                setActivity(obj);
            }
        });
    }
    const getStudentList = (event, obj, sectionIdOverride) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const selectedClassId = event.target.value;
        
        // Clear student list if no class is selected
        if (!selectedClassId || selectedClassId === '') {
            setStudentList([]);
            return;
        }
        
        const getStuList = {
            classId: selectedClassId,
        };
        // If a section is selected (from state or override), filter students by section as well
        const effectiveSectionId = sectionIdOverride !== undefined ? sectionIdOverride : sectionId;
        if (effectiveSectionId) {
            getStuList.sectionId = effectiveSectionId;
        }

        StudentService.getAllStudentById(userDetails.schooleId, getStuList).then((res) => {
            let studentDetails = res.map(res => {
                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            });

            setStudentList(studentDetails);
            // Refresh "already added" highlights whenever class/section changes
            try {
                const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
                ActivityService.getExistingActivityKeys({
                    schooleId,
                    classId: selectedClassId,
                    sectionId: effectiveSectionId || null,
                    studentId: (formik?.values?.studentId || []),
                    isEventForAllStudent: Boolean(formik?.values?.isEventForAllStudent),
                }).then((r) => {
                    const data = r?.data || r;
                    const keys = Array.isArray(data?.keys) ? data.keys : [];
                    setExistingKeySet(new Set(keys));
                    setExistingKeyStudents(data?.byKey || {});
                }).catch(() => setExistingKeySet(new Set()));
            } catch (e) {
                setExistingKeySet(new Set());
                setExistingKeyStudents({});
            }

            if (obj) {
                setActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
            setStudentList([]);
            setExistingKeySet(new Set());
            setExistingKeyStudents({});
        });
    }


    const getStudentActivityList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        ActivityTabelService.getStudentActivity(userDetails.schooleId, false).then((res) => {
            setActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }


    const editActivity = (useractivitys, isAddMore, group) => {
        if (!isActivityRecord(useractivitys)) return;

        const obj = JSON.parse(JSON.stringify(useractivitys));
        obj.classId = normalizeRefId(useractivitys.classId || group?.classId);
        obj.sectionId = normalizeRefId(useractivitys.sectionId || group?.sectionId);
        obj.studentId = normalizeStudentIds(useractivitys.studentId, group?.studentId);
        obj.superActivityId = normalizeRefId(useractivitys.superActivityId);
        obj.activityId = normalizeRefId(useractivitys.activityId);
        obj.subActivityId = normalizeRefId(useractivitys.subActivityId);
        obj.isEdit = true;

        if (isAddMore) {
            delete obj._id;
        }

        setActivity(obj);
        setOpen(true);

        if (obj.classId) {
            loadDialogSectionList(obj.classId);
            getSuperActivityList({ target: { value: obj.classId } }, obj);
            getStudentList({ target: { value: obj.classId } }, obj, obj.sectionId || undefined);
        }
        if (obj.superActivityId) {
            getActivityList({ target: { value: obj.superActivityId } }, obj);
        }
        if (obj.activityId) {
            getSubActivityList({ target: { value: obj.activityId } }, obj);
        }
    }

    const deleteActivities = async (activityIds) => {
        const ids = (activityIds || []).map(String).filter(Boolean);
        if (!ids.length) return;

        try {
            for (const id of ids) {
                await ActivityService.deleteActivity(id);
            }
            await refreshActivityTable();
            await refreshExistingActivityKeys();
            setOpenDeleteDialog(false);
            setPendingDeleteIds([]);
            setSelectedTableActivityIds((prev) => prev.filter((id) => !ids.includes(id)));
            setMessageDialogContent({
                title: 'Success',
                message: ids.length === 1
                    ? 'Activity deleted successfully.'
                    : `${ids.length} activities deleted successfully.`,
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setOpenDeleteDialog(false);
            setPendingDeleteIds([]);
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to delete activity.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        }
    };

    const handleDeleteClick = (activityId) => {
        setPendingDeleteIds([String(activityId)]);
        setOpenDeleteDialog(true);
    };

    const handleBulkDeleteClick = () => {
        if (!selectedTableActivityIds.length) return;
        setPendingDeleteIds([...selectedTableActivityIds]);
        setOpenDeleteDialog(true);
    };

    const handleDeleteConfirm = () => {
        if (pendingDeleteIds.length > 0) {
            deleteActivities(pendingDeleteIds);
        }
    };

    const handleDeleteCancel = () => {
        setOpenDeleteDialog(false);
        setPendingDeleteIds([]);
    };
    const patchActivityPublicStatus = (activityId, publicStatus) => {
        setActivityList((prev) => prev.map((group) => ({
            ...group,
            activityRecordsId: (group.activityRecordsId || []).map((record) =>
                isActivityRecord(record) && String(record._id) === String(activityId)
                    ? { ...record, publicStatus }
                    : record
            ),
        })));
    };

    const handlePublicStatusChange = (activity, publicStatus) => {
        const isPublishing = publicStatus === 'publish';

        if (isPublishing && getActivityKeyIndex(activity?.key) === -1) {
            setMessageDialogContent({
                title: 'Key Required',
                message: 'Please select a key (P, WA, WI or M) before publishing this activity.',
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        setStatusConfirmDialog({
            open: true,
            activity,
            publicStatus,
        });
    };

    const closeStatusConfirmDialog = () => {
        setStatusConfirmDialog({ open: false, activity: null, publicStatus: '' });
    };

    const confirmPublicStatusChange = () => {
        const { activity, publicStatus } = statusConfirmDialog;
        if (!activity?._id || !publicStatus) {
            closeStatusConfirmDialog();
            return;
        }

        const isPublishing = publicStatus === 'publish';
        closeStatusConfirmDialog();

        ActivityService.upadePublicStatus({
            publicStatus,
            _id: activity._id,
        }).then(() => {
            patchActivityPublicStatus(activity._id, publicStatus);
            setMessageDialogContent({
                title: 'Success',
                message: isPublishing
                    ? 'Reports published successfully'
                    : 'Activity moved back to draft',
                type: 'success',
            });
            setOpenMessageDialog(true);
        }).catch((err) => {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to update public status.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        });
    };

    const patchActivityMedia = (activityId, { imageURL, videoURL }) => {
        setActivityList((prev) => prev.map((group) => ({
            ...group,
            activityRecordsId: (group.activityRecordsId || []).map((record) =>
                isActivityRecord(record) && String(record._id) === String(activityId)
                    ? {
                        ...record,
                        ...(imageURL !== undefined ? { imageURL } : {}),
                        ...(videoURL !== undefined ? { videoURL } : {}),
                    }
                    : record
            ),
        })));
    };

    const patchActivityRemarks = (activityId, remarks) => {
        setActivityList((prev) => prev.map((group) => ({
            ...group,
            activityRecordsId: (group.activityRecordsId || []).map((record) =>
                isActivityRecord(record) && String(record._id) === String(activityId)
                    ? { ...record, remarks }
                    : record
            ),
        })));
    };

    const getRemarksValue = (activity) => (activity?.remarks || '').trim();

    const hasSavedRemarks = (activity) => getRemarksValue(activity).length > 0;

    const openObservationDialog = (activity) => {
        setObservationDialog({
            open: true,
            activity,
            text: activity?.remarks || '',
            saving: false,
        });
    };

    const closeObservationDialog = () => {
        setObservationDialog({
            open: false,
            activity: null,
            text: '',
            saving: false,
        });
    };

    const handleObservationDialogChange = (text) => {
        setObservationDialog((prev) => ({ ...prev, text }));
    };

    const saveObservationDialog = async () => {
        const { activity, text } = observationDialog;
        if (!activity?._id) return;

        const activityId = activity._id;
        const newRemarks = (text || '').trim();
        const oldRemarks = (activity.remarks || '').trim();
        if (newRemarks === oldRemarks) {
            closeObservationDialog();
            return;
        }

        setObservationDialog((prev) => ({ ...prev, saving: true }));
        try {
            await ActivityService.patchActivityRecord({
                _id: activityId,
                remarks: newRemarks,
            });
            patchActivityRemarks(activityId, newRemarks);
            setObservationExpanded((prev) => ({ ...prev, [activityId]: false }));
            closeObservationDialog();
            setMessageDialogContent({
                title: 'Success',
                message: newRemarks ? 'Observation saved successfully.' : 'Observation removed.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setObservationDialog((prev) => ({ ...prev, saving: false }));
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to save observation.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        }
    };

    const renderObservationCell = (activity) => {
        const isExpanded = observationExpanded[activity._id] === true;
        const saved = hasSavedRemarks(activity);

        if (!saved) {
            return (
                <Button
                    size="small"
                    startIcon={<AddIcon style={{ fontSize: 16 }} />}
                    onClick={() => openObservationDialog(activity)}
                    style={{
                        textTransform: 'none',
                        color: '#0f3b62',
                        whiteSpace: 'nowrap',
                    }}
                >
                    Add Observation
                </Button>
            );
        }

        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{ gap: 6, minWidth: 120 }}
            >
                <Tooltip title={isExpanded ? 'Hide observation' : 'View observation'}>
                    <IconButton
                        className={classes.observationIconAction}
                        size="small"
                        onClick={() => setObservationExpanded((prev) => ({
                            ...prev,
                            [activity._id]: !prev[activity._id],
                        }))}
                    >
                        {isExpanded
                            ? <VisibilityOffIcon fontSize="small" />
                            : <VisibilityIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
                <Button
                    size="small"
                    startIcon={<EditIcon style={{ fontSize: 14 }} />}
                    onClick={() => openObservationDialog(activity)}
                    style={{
                        textTransform: 'none',
                        color: '#0f3b62',
                        fontSize: '0.72rem',
                        padding: '2px 6px',
                        minWidth: 0,
                    }}
                >
                    Edit Observation
                </Button>
            </Box>
        );
    };

    const formatObservationHeaderDate = (dateString) => {
        const formatted = formatDate(dateString);
        return formatted ? formatted.replace(/\//g, '-') : '—';
    };

    const renderObservationExpandRow = (activity) => {
        const value = getRemarksValue(activity);
        const activityLabel = activity.activityId?.activityName
            || activity.subActivityId?.subActivityName
            || 'Activity';

        return (
            <TableRow key={`${activity._id}-observation`} className={classes.noteExpandRow}>
                <TableCell colSpan={visibleColumnCount}>
                    <Box className={classes.noteExpandBox}>
                        <NoteIcon style={{ color: '#1769d6', marginTop: 2, flexShrink: 0 }} />
                        <Box flex={1}>
                            <Typography
                                style={{
                                    fontSize: '0.72rem',
                                    fontWeight: 700,
                                    color: '#9aa6b6',
                                    textTransform: 'uppercase',
                                    marginBottom: 4,
                                }}
                            >
                                Observation · {activityLabel} · {formatObservationHeaderDate(activity.date)}
                            </Typography>
                            <Typography
                                style={{
                                    color: '#0f2d4d',
                                    fontSize: '0.9rem',
                                    lineHeight: 1.65,
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                {value || 'No observation text recorded.'}
                            </Typography>
                        </Box>
                    </Box>
                </TableCell>
            </TableRow>
        );
    };

    const closeImagesStoreDialog = () => {
        setImagesStoreDialog({
            open: false,
            activity: null,
            loading: false,
            saving: false,
            error: '',
            imagesStoreRows: [],
            selectedStoreId: IMAGES_STORE_ALL_KEY,
            selectedUrls: [],
        });
    };

    const openImagesStoreDialog = async (activity) => {
        if (!activity?._id) return;

        const existingImages = getActivityImageUrls(activity);
        const existingVideos = getActivityVideoUrls(activity);
        if (
            existingImages.length >= MAX_ACTIVITY_IMAGES
            && existingVideos.length >= MAX_ACTIVITY_VIDEOS
        ) {
            setMessageDialogContent({
                title: 'Limit reached',
                message: `Maximum ${MAX_ACTIVITY_IMAGES} images and ${MAX_ACTIVITY_VIDEOS} videos allowed per activity.`,
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
        const resolvedClassId = normalizeRefId(activity?.classId) || classId;
        if (!resolvedClassId || !userDetails.schooleId) {
            setMessageDialogContent({
                title: 'Error',
                message: 'Class is required to load Images Store.',
                type: 'error',
            });
            setOpenMessageDialog(true);
            return;
        }

        setImagesStoreDialog({
            open: true,
            activity,
            loading: true,
            saving: false,
            error: '',
            imagesStoreRows: [],
            selectedStoreId: IMAGES_STORE_ALL_KEY,
            selectedUrls: [],
        });

        try {
            const body = { schooleId: userDetails.schooleId, classId: resolvedClassId };
            const resolvedSectionId = normalizeRefId(activity?.sectionId) || sectionId;
            if (resolvedSectionId) body.sectionId = resolvedSectionId;

            const storeRes = await ImagesStoreService.findImagesStoreList(body);
            setImagesStoreDialog((prev) => ({
                ...prev,
                loading: false,
                imagesStoreRows: Array.isArray(storeRes) ? storeRes : [],
            }));
        } catch (err) {
            setImagesStoreDialog((prev) => ({
                ...prev,
                loading: false,
                error: err?.response?.data?.message || 'Failed to load Images Store.',
            }));
        }
    };

    const toggleImagesStoreSelection = (url, mediaType) => {
        setImagesStoreDialog((prev) => {
            const activity = prev.activity;
            if (!activity) return prev;

            const resolvedType = mediaType || getMediaTypeFromUrl(url);
            const isVideo = resolvedType === 'video';
            const existing = isVideo
                ? getActivityVideoUrls(activity)
                : getActivityImageUrls(activity);
            const max = isVideo ? MAX_ACTIVITY_VIDEOS : MAX_ACTIVITY_IMAGES;
            const remaining = max - existing.length;
            const selectedOfType = prev.selectedUrls.filter(
                (u) => getMediaTypeFromUrl(u) === resolvedType,
            );

            if (prev.selectedUrls.includes(url)) {
                return { ...prev, selectedUrls: prev.selectedUrls.filter((u) => u !== url) };
            }

            if (existing.includes(url) || selectedOfType.length >= remaining) {
                return prev;
            }

            return { ...prev, selectedUrls: [...prev.selectedUrls, url] };
        });
    };

    const saveImagesFromStore = async () => {
        const { activity, selectedUrls } = imagesStoreDialog;
        if (!activity?._id || selectedUrls.length === 0) return;

        const existingImages = getActivityImageUrls(activity);
        const existingVideos = getActivityVideoUrls(activity);
        const newImageUrls = selectedUrls
            .filter((url) => getMediaTypeFromUrl(url) === 'image' && !existingImages.includes(url))
            .slice(0, MAX_ACTIVITY_IMAGES - existingImages.length);
        const newVideoUrls = selectedUrls
            .filter((url) => getMediaTypeFromUrl(url) === 'video' && !existingVideos.includes(url))
            .slice(0, MAX_ACTIVITY_VIDEOS - existingVideos.length);

        if (newImageUrls.length === 0 && newVideoUrls.length === 0) {
            closeImagesStoreDialog();
            return;
        }

        setImagesStoreDialog((prev) => ({ ...prev, saving: true }));
        try {
            const updatedImages = [...existingImages, ...newImageUrls];
            const updatedVideos = [...existingVideos, ...newVideoUrls];
            await ActivityService.patchActivityRecord({
                _id: activity._id,
                imageURL: updatedImages,
                videoURL: updatedVideos,
            });
            patchActivityMedia(activity._id, {
                imageURL: updatedImages,
                videoURL: updatedVideos,
            });
            setImagesExpanded((prev) => ({ ...prev, [activity._id]: false }));
            closeImagesStoreDialog();
            const addedCount = newImageUrls.length + newVideoUrls.length;
            setMessageDialogContent({
                title: 'Success',
                message: addedCount > 1
                    ? `${addedCount} items added from Images Store.`
                    : 'Media added from Images Store.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setImagesStoreDialog((prev) => ({ ...prev, saving: false }));
            setMessageDialogContent({
                title: 'Error',
                message: err?.response?.data?.message || 'Failed to add media from Images Store.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        }
    };

    const handleDeleteActivityImage = async (activity, urlToRemove) => {
        if (!activity?._id || !urlToRemove) return;
        if (!window.confirm('Delete this uploaded image?')) return;

        const existing = getActivityImageUrls(activity);
        const updatedFiles = existing.filter((url) => url !== urlToRemove);
        if (updatedFiles.length === existing.length) return;

        const mediaKey = `${activity._id}-img-${urlToRemove}`;
        setDeletingMediaKey(mediaKey);
        try {
            await ActivityService.patchActivityRecord({
                _id: activity._id,
                imageURL: updatedFiles,
            });
            patchActivityMedia(activity._id, { imageURL: updatedFiles });
            if (updatedFiles.length === 0 && getActivityVideoUrls(activity).length === 0) {
                setImagesExpanded((prev) => {
                    const next = { ...prev };
                    delete next[activity._id];
                    return next;
                });
            }
            setMessageDialogContent({
                title: 'Success',
                message: 'Image deleted successfully.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to delete image.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setDeletingMediaKey(null);
        }
    };

    const handleActivityImageUpload = async (e, activity) => {
        const files = e.target.files ? Array.from(e.target.files) : [];
        if (files.length === 0 || !activity?._id) return;

        if (files.length > MAX_ACTIVITY_IMAGES) {
            setMessageDialogContent({
                title: 'Limit exceeded',
                message: `You can upload at most ${MAX_ACTIVITY_IMAGES} images at a time.`,
                type: 'error',
            });
            setOpenMessageDialog(true);
            if (e?.target) e.target.value = '';
            return;
        }

        const existing = getActivityImageUrls(activity);
        const remaining = MAX_ACTIVITY_IMAGES - existing.length;
        if (remaining <= 0) {
            setMessageDialogContent({
                title: 'Limit reached',
                message: `Maximum ${MAX_ACTIVITY_IMAGES} images allowed per activity.`,
                type: 'error',
            });
            setOpenMessageDialog(true);
            if (e?.target) e.target.value = '';
            return;
        }

        const filesToUpload = files.slice(0, remaining);
        if (filesToUpload.length < files.length) {
            setMessageDialogContent({
                title: 'Limit reached',
                message: `Only ${filesToUpload.length} image(s) will be added. Maximum ${MAX_ACTIVITY_IMAGES} images allowed per activity.`,
                type: 'info',
            });
            setOpenMessageDialog(true);
        }

        setUploadingImageId(activity._id);
        try {
            const uploadResults = await Promise.all(
                filesToUpload.map((file) => {
                    const formData = new FormData();
                    formData.append('image', file);
                    formData.append('imageName', file.name);
                    return StudentService.uploadImage(formData);
                })
            );

            const urls = uploadResults.map((res) => res?.url).filter(Boolean);
            if (urls.length === 0) {
                setMessageDialogContent({
                    title: 'Error',
                    message: 'Failed to upload images.',
                    type: 'error',
                });
                setOpenMessageDialog(true);
                return;
            }

            const updatedFiles = [...existing, ...urls];

            await ActivityService.patchActivityRecord({
                _id: activity._id,
                imageURL: updatedFiles,
            });

            patchActivityMedia(activity._id, { imageURL: updatedFiles });
            setImagesExpanded((prev) => ({ ...prev, [activity._id]: false }));
            setMessageDialogContent({
                title: 'Success',
                message: urls.length > 1
                    ? `${urls.length} images uploaded successfully.`
                    : 'Image uploaded successfully.',
                type: 'success',
            });
            setOpenMessageDialog(true);
        } catch (err) {
            setMessageDialogContent({
                title: 'Error',
                message: err.response?.data?.message || 'Failed to upload images.',
                type: 'error',
            });
            setOpenMessageDialog(true);
        } finally {
            setUploadingImageId(null);
            if (e?.target) e.target.value = '';
        }
    };

    const openImageAddMenu = (event, activity, uploadInputId) => {
        setImageAddMenu({
            anchorEl: event.currentTarget,
            activity,
            uploadInputId,
        });
    };

    const closeImageAddMenu = () => {
        setImageAddMenu({
            anchorEl: null,
            activity: null,
            uploadInputId: '',
        });
    };

    const handleImageAddMenuUpload = () => {
        const { uploadInputId } = imageAddMenu;
        const input = document.getElementById(uploadInputId);
        if (input) input.click();
        closeImageAddMenu();
    };

    const handleImageAddMenuStore = () => {
        const { activity } = imageAddMenu;
        closeImageAddMenu();
        if (activity) openImagesStoreDialog(activity);
    };

    const renderActivityImageAddActions = (activity, images, isUploading, uploadInputId) => {
        const videos = getActivityVideoUrls(activity);
        const canAddMore = images.length < MAX_ACTIVITY_IMAGES || videos.length < MAX_ACTIVITY_VIDEOS;
        const canUploadImages = images.length < MAX_ACTIVITY_IMAGES;
        const addDisabled = isUploading || !canAddMore;
        const uploadDisabled = isUploading || !canUploadImages;
        const hasImages = images.length > 0 || videos.length > 0;
        const buttonLabel = isUploading
            ? 'Uploading...'
            : (hasImages ? 'Edit Media' : 'Add Media');

        return (
            <Box display="flex" flexDirection="column" style={{ gap: 4 }}>
                <input
                    id={uploadInputId}
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    disabled={uploadDisabled}
                    onChange={(ev) => handleActivityImageUpload(ev, activity)}
                />
                <Button
                    size="small"
                    startIcon={
                        isUploading
                            ? <CircularProgress size={14} style={{ color: '#9e9e9e' }} />
                            : hasImages
                                ? <EditIcon style={{ fontSize: 18 }} />
                                : <CloudUploadIcon style={{ fontSize: 18 }} />
                    }
                    endIcon={!isUploading ? <ArrowDropDownIcon /> : null}
                    disabled={addDisabled}
                    onClick={(e) => openImageAddMenu(e, activity, uploadInputId)}
                    style={{
                        color: addDisabled ? '#9e9e9e' : '#0f3b62',
                        textTransform: 'none',
                    }}
                >
                    {buttonLabel}
                </Button>
            </Box>
        );
    };

    const renderActivityImagesCell = (activity) => {
        const images = getActivityImageUrls(activity);
        const videos = getActivityVideoUrls(activity);
        const mediaCount = images.length + videos.length;
        const isUploading = uploadingImageId === activity._id;
        const hasUploadedMedia = mediaCount > 0;
        const isExpanded = imagesExpanded[activity._id] === true;
        const uploadInputId = `activity-image-upload-${activity._id}`;
        const mediaCountLabel = `${images.length}/${MAX_ACTIVITY_IMAGES} img · ${videos.length}/${MAX_ACTIVITY_VIDEOS} vid`;

        if (!hasUploadedMedia) {
            return (
                <Box display="flex" flexDirection="column" style={{ gap: 6, minWidth: 140 }}>
                    {renderActivityImageAddActions(activity, images, isUploading, uploadInputId)}
                </Box>
            );
        }

        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{ gap: 6, minWidth: 140 }}
            >
                {isExpanded && (
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="nowrap"
                        alignItems="flex-start"
                        style={{ gap: 8, overflowX: 'auto', maxWidth: 320, paddingBottom: 2 }}
                    >
                        {images.map((url, idx) => {
                            const imageDeleteKey = `${activity._id}-img-${url}`;
                            const isDeletingImage = deletingMediaKey === imageDeleteKey;
                            return (
                            <Box
                                key={`${activity._id}-img-${idx}`}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                style={{ gap: 2, flex: '0 0 auto' }}
                            >
                                <Box style={{ position: 'relative', width: 40, height: 40 }}>
                                    <img
                                        src={url}
                                        alt={`Activity ${idx + 1}`}
                                        loading="lazy"
                                        decoding="async"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            objectFit: 'cover',
                                            borderRadius: 4,
                                            border: '1px solid #e0e0e0',
                                            cursor: 'pointer',
                                            opacity: isDeletingImage ? 0.5 : 1,
                                        }}
                                        onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
                                    />
                                    <Tooltip title="Delete image">
                                        <span>
                                            <IconButton
                                                size="small"
                                                disabled={isDeletingImage || isUploading}
                                                onClick={() => handleDeleteActivityImage(activity, url)}
                                                style={{
                                                    position: 'absolute',
                                                    top: -8,
                                                    right: -8,
                                                    width: 20,
                                                    height: 20,
                                                    padding: 0,
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #e0e0e0',
                                                    color: '#c62828',
                                                }}
                                            >
                                                {isDeletingImage
                                                    ? <CircularProgress size={10} style={{ color: '#c62828' }} />
                                                    : <DeleteIcon style={{ fontSize: 12 }} />}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                                <Button
                                    size="small"
                                    startIcon={<GetAppIcon style={{ fontSize: 14 }} />}
                                    onClick={() => downloadFromUrl(url, `activity-${idx + 1}-${getFileNameFromUrl(url)}`)}
                                    disabled={isDeletingImage}
                                    style={{
                                        color: '#0f3b62',
                                        justifyContent: 'center',
                                        textTransform: 'none',
                                        fontSize: '0.7rem',
                                        padding: '0 4px',
                                        minWidth: 0,
                                    }}
                                >
                                    Download
                                </Button>
                            </Box>
                            );
                        })}
                        {videos.map((url, idx) => (
                            <Box
                                key={`${activity._id}-vid-${idx}`}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                style={{ gap: 2, flex: '0 0 auto' }}
                            >
                                <Box
                                    onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
                                    style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: 4,
                                        border: '1px solid #e0e0e0',
                                        backgroundColor: '#0f2d4d',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <PlayArrowIcon style={{ color: '#fff', fontSize: 22 }} />
                                </Box>
                                <Button
                                    size="small"
                                    startIcon={<GetAppIcon style={{ fontSize: 14 }} />}
                                    onClick={() => downloadFromUrl(url, `activity-video-${idx + 1}-${getFileNameFromUrl(url)}`)}
                                    style={{
                                        color: '#0f3b62',
                                        justifyContent: 'center',
                                        textTransform: 'none',
                                        fontSize: '0.7rem',
                                        padding: '0 4px',
                                        minWidth: 0,
                                    }}
                                >
                                    Download
                                </Button>
                            </Box>
                        ))}
                    </Box>
                )}
                <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                    <Tooltip title={isExpanded ? 'Hide media' : 'Show media'}>
                        <IconButton
                            className={classes.observationIconAction}
                            size="small"
                            onClick={() => setImagesExpanded((prev) => ({
                                ...prev,
                                [activity._id]: !prev[activity._id],
                            }))}
                        >
                            {isExpanded
                                ? <VisibilityOffIcon fontSize="small" />
                                : <VisibilityIcon fontSize="small" />}
                        </IconButton>
                    </Tooltip>
                    <Chip
                        size="small"
                        clickable
                        onClick={() => setImagesExpanded((prev) => ({
                            ...prev,
                            [activity._id]: !prev[activity._id],
                        }))}
                        label={isExpanded ? 'Hide' : mediaCountLabel}
                        style={{
                            backgroundColor: '#eef4ff',
                            color: '#1769d6',
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}
                    />
                </Box>
                {renderActivityImageAddActions(activity, images, isUploading, uploadInputId)}
            </Box>
        );
    };


    return (

        <>
            {/* Page header */}
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Activity Planner</Typography>
                    <Typography className={classes.pageSubtitle}>
                        Plan and manage class activities for students.
                    </Typography>
                </Box>
                <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                    <Button
                        className={classes.planBtn}
                        variant="outlined"
                        startIcon={<EventIcon />}
                        onClick={() => history.push('/app/quickactivity')}
                        style={{
                            borderColor: '#1769d6',
                            color: 'white',
                            backgroundColor: 'rgb(15, 59, 98)',
                        }}
                    >
                        Quick activity allotment
                    </Button>
                    <Button
                        className={classes.planBtn}
                        variant="contained"
                        startIcon={<EventIcon />}
                        onClick={() => handleOpen(true)}
                    >
                        Activity planner Multiple
                    </Button>
                </Box>
            </Box>

            {/* Filters card */}
            <Card className={classes.filtersCard} elevation={0}>
                <Box className={classes.filtersTopRow}>
                    <Box display="flex" alignItems="center" gridGap={16} flexWrap="wrap">
                        <Box
                            className={classes.filtersChip}
                            onClick={() => setFiltersOpen((o) => !o)}
                            role="button"
                            tabIndex={0}
                        >
                            <FilterListIcon fontSize="small" />
                            <span>Filters</span>
                            <span className={classes.activityCountBadge}>{activeFilterCount}</span>
                            {filtersOpen ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                        </Box>
                        <Box display="flex" alignItems="center" gridGap={8}>
                            <Typography style={{ fontSize: '0.8rem', color: '#46566b', fontWeight: 600 }}>
                                Quick Range
                            </Typography>
                            <Box className={classes.quickRangeWrap}>
                                <Button
                                    className={`${classes.quickRangeBtn} ${quickRange === 'week' ? classes.quickRangeBtnActive : ''}`}
                                    onClick={() => applyQuickRange('week')}
                                >
                                    This Week
                                </Button>
                                <Button
                                    className={`${classes.quickRangeBtn} ${quickRange === 'month' ? classes.quickRangeBtnActive : ''}`}
                                    onClick={() => applyQuickRange('month')}
                                >
                                    This Month
                                </Button>
                                <Button
                                    className={`${classes.quickRangeBtn} ${quickRange === 'custom' ? classes.quickRangeBtnActive : ''}`}
                                    startIcon={<CalendarTodayIcon style={{ fontSize: 14 }} />}
                                    onClick={() => applyQuickRange('custom')}
                                >
                                    Custom
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" gridGap={10}>
                        <Button
                            variant="contained"
                            className={classes.exportBtn}
                            startIcon={printing ? <CircularProgress size={16} style={{ color: '#fff' }} /> : <PrintIcon />}
                            onClick={handlePrintFilteredData}
                            disabled={printing || activityTableLoading || !classId}
                        >
                            {printing ? 'Preparing…' : 'Print'}
                        </Button>
                        <ExportExcel excelData={exportExcelData} fileName={'Activity recorder'} />
                    </Box>
                </Box>

                <Collapse in={filtersOpen}>
                    <Box mt={2}>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Typography className={classes.fieldLabel}>
                                    <SchoolIcon style={{ fontSize: 16 }} /> Class
                                    <span style={{ color: '#e53935' }}>*</span>
                                </Typography>
                                <FormControl fullWidth variant="outlined" size="small" required>
                                    <Select
                                        displayEmpty
                                        name="classId"
                                        value={classId}
                                        onChange={e => {
                                            const value = e.target.value;
                                            setClassId(value);
                                            setSectionId('');
                                            getStudentList(e, null, '');
                                            getSectionListByClass(value);
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Class</em></MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Typography className={classes.fieldLabel}>
                                    <PersonIcon style={{ fontSize: 16 }} /> Section
                                </Typography>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Select
                                        displayEmpty
                                        name="sectionId"
                                        value={sectionId}
                                        onChange={(e) => {
                                            const selectedSectionId = e.target.value;
                                            setSectionId(selectedSectionId);
                                            if (classId) {
                                                getStudentList({ target: { value: classId } }, null, selectedSectionId || undefined);
                                            }
                                        }}
                                        disabled={!classId || sectionList.length === 0}
                                    >
                                        <MenuItem value=""><em>All Sections</em></MenuItem>
                                        {sectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Typography className={classes.fieldLabel}>
                                    <PersonIcon style={{ fontSize: 16 }} /> Student
                                </Typography>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Select
                                        displayEmpty
                                        name="studentId"
                                        value={studentId}
                                        onChange={e => { setStudentId(e.target.value) }}
                                    >
                                        <MenuItem value=""><em>All Students</em></MenuItem>
                                        {studentList.map(({ index, _id, studentName }) => (
                                            <MenuItem key={index} value={_id}>{studentName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={3}>
                                <Typography className={classes.fieldLabel}>
                                    <CalendarTodayIcon style={{ fontSize: 16 }} /> Date Range
                                </Typography>
                                <Box display="flex" gridGap={8}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        type="date"
                                        inputProps={{ min: '2016-11-10' }}
                                        value={startDate1}
                                        onChange={e => {
                                            setQuickRange('custom');
                                            setStartDate1(e.target.value);
                                            if (endDate1 && e.target.value && new Date(e.target.value) > new Date(endDate1)) {
                                                setEndDate1('');
                                            }
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        type="date"
                                        inputProps={{ min: startDate1 || '2016-11-10' }}
                                        value={endDate1}
                                        onChange={e => {
                                            const selectedEndDate = e.target.value;
                                            setQuickRange('custom');
                                            if (!startDate1 || new Date(selectedEndDate) >= new Date(startDate1)) {
                                                setEndDate1(selectedEndDate);
                                            } else {
                                                setMessageDialogContent({
                                                    title: 'Validation Error',
                                                    message: 'End date must be greater than or equal to start date',
                                                    type: 'error'
                                                });
                                                setOpenMessageDialog(true);
                                            }
                                        }}
                                        error={Boolean(endDate1 && startDate1 && new Date(endDate1) < new Date(startDate1))}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Collapse in={moreFiltersOpen}>
                            <Grid container spacing={2} style={{ marginTop: 4 }}>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <Typography className={classes.fieldLabel}>Status</Typography>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                                            <MenuItem value="all">All Status</MenuItem>
                                            <MenuItem value="draft">Draft</MenuItem>
                                            <MenuItem value="published">Published</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <Typography className={classes.fieldLabel}>Key</Typography>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <Select value={keyFilter} onChange={(e) => setKeyFilter(e.target.value)}>
                                            <MenuItem value="all">All Keys</MenuItem>
                                            {keyOptions.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Collapse>

                        <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" mt={2} gridGap={10}>
                            <Button
                                size="small"
                                onClick={() => setMoreFiltersOpen((o) => !o)}
                                endIcon={moreFiltersOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                                style={{ textTransform: 'none', color: '#46566b', fontWeight: 600 }}
                            >
                                More Filters: {moreFiltersOpen ? 'Hide' : 'Show'}
                            </Button>
                            <Box display="flex" gridGap={10}>
                                <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                                    Reset
                                </Button>
                                <Button
                                    className={classes.applyBtn}
                                    variant="contained"
                                    startIcon={<FilterListIcon />}
                                    onClick={() => onSubmit(startDate1, endDate1)}
                                >
                                    Apply Filters
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Collapse>
            </Card>
            <Card className={classes.tableCard} elevation={0}>
                {/* Toolbar */}
                <Box className={classes.toolbar} px={2} pt={2}>
                    <Box display="flex" alignItems="center" gridGap={16} flexWrap="wrap">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={highlightPrevWeek}
                                    onChange={(e) => setHighlightPrevWeek(e.target.checked)}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={
                                <Typography variant="body2" style={{ color: '#46566b' }}>
                                    Highlight rows with previous week activities
                                </Typography>
                            }
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showMaster}
                                    onChange={(e) => setShowMaster(e.target.checked)}
                                    color="primary"
                                    size="small"
                                    inputProps={{ 'aria-label': 'Show mastered activities' }}
                                />
                            }
                            label={
                                <Typography variant="body2" style={{ color: '#46566b' }}>
                                    Show Master
                                </Typography>
                            }
                        />
                        {/* <Box className={classes.keyLegendWrap}>
                            {KEY_LEGEND_ITEMS.map((item) => {
                                const LegendIcon = item.Icon;
                                return (
                                    <Tooltip key={item.key} title={item.description} arrow>
                                        <Box
                                            className={classes.keyLegendCard}
                                            style={{ backgroundColor: item.bg }}
                                        >
                                            <span
                                                className={classes.keyLegendIcon}
                                                style={{ backgroundColor: item.color, color: '#fff' }}
                                            >
                                                <LegendIcon style={{ fontSize: 13 }} />
                                            </span>
                                            <Box className={classes.keyLegendText}>
                                                <Box className={classes.keyLegendTitleRow}>
                                                    <Typography
                                                        component="span"
                                                        className={classes.keyLegendTitle}
                                                        style={{ color: item.color }}
                                                    >
                                                        {item.title}
                                                    </Typography>
                                                    {item.badge && (
                                                        <span
                                                            className={classes.keyLegendBadge}
                                                            style={{
                                                                color: item.color,
                                                                backgroundColor: `${item.color}18`,
                                                            }}
                                                        >
                                                            {item.badge}
                                                        </span>
                                                    )}
                                                </Box>
                                                <Typography component="span" className={classes.keyLegendDesc}>
                                                    {item.description}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Tooltip>
                                );
                            })}
                        </Box> */}
                    </Box>
                    <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                        {selectedTableActivityIds.length > 0 && (
                            <Button
                                variant="contained"
                                startIcon={<DeleteIcon />}
                                onClick={handleBulkDeleteClick}
                                style={{
                                    textTransform: 'none',
                                    backgroundColor: '#dc3545',
                                    color: '#fff',
                                    fontWeight: 600,
                                }}
                            >
                                Delete selected ({selectedTableActivityIds.length})
                            </Button>
                        )}
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search activities..."
                            value={tableSearch}
                            onChange={handleTableSearchChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" style={{ color: '#9aa6b6' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                            variant="outlined"
                            startIcon={<ViewColumnIcon />}
                            onClick={(e) => setColumnMenuAnchor(e.currentTarget)}
                            style={{ textTransform: 'none', color: '#46566b', borderColor: '#d9dee7' }}
                        >
                            Column
                        </Button>
                        <Tooltip title="Refresh">
                            <IconButton className={classes.iconBtnOutlined} onClick={() => onSubmit(startDate1, endDate1)}>
                                <RefreshIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                {highlightPrevWeek && (
                    <Box px={2} pb={1} display="flex" alignItems="center" gridGap={8}>
                        <Box
                            style={{
                                width: 12,
                                height: 12,
                                borderRadius: 3,
                                backgroundColor: '#ffebee',
                                border: '1px solid rgba(229,57,53,0.25)',
                            }}
                        />
                        <Typography variant="caption" style={{ color: '#9aa6b6' }}>
                            Pink rows show previous week (overdue) activities.
                        </Typography>
                    </Box>
                )}

                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 540 }}>
                    <Table stickyHeader className="mb-0 dashboard-table-row-hover">
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox" style={headerCellStyle}>
                                    <Checkbox
                                        color="primary"
                                        size="small"
                                        indeterminate={someVisibleActivitiesSelected && !allVisibleActivitiesSelected}
                                        checked={allVisibleActivitiesSelected}
                                        onChange={toggleSelectAllVisibleActivities}
                                        disabled={activityTableLoading || visiblePaginatedActivityIds.length === 0}
                                        inputProps={{ 'aria-label': 'Select all activities on this page' }}
                                    />
                                </TableCell>
                                {/* <TableCell style={headerCellStyle}>Class</TableCell>
                                <TableCell style={headerCellStyle}>Section</TableCell> */}
                                {columnConfig.map((col) =>
                                    visibleCols[col.id] ? (
                                        <TableCell key={col.id} style={headerCellStyle}>{col.label}</TableCell>
                                    ) : null
                                )}
                                <TableCell style={headerCellStyle} align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {activityTableLoading
                                ? renderActivityTableSkeleton()
                                : activityList
                                .map((group, groupIndex) => {
                                    const studentName = `${group.studentId?.firstName || ''} ${group.studentId?.lastName || ''}`.trim();
                                    const records = (group.activityRecordsId || [])
                                        .filter(isActivityRecord)
                                        .filter((a) => matchesActivityFilters(a, studentName));
                                    if (records.length === 0) return null;
                                    const studentKey = getStudentGroupKey(group, groupIndex);
                                    const expanded = isStudentActivityExpanded(studentKey);
                                    const keyCounts = records.reduce((acc, rec) => {
                                        const idx = getActivityKeyIndex(rec.key);
                                        if (idx === -1) acc.notSet += 1;
                                        else acc[KEY_SEQUENCE[idx]] += 1;
                                        return acc;
                                    }, { P: 0, WA: 0, WI: 0, M: 0, notSet: 0 });
                                    const keySummary = [
                                        { label: 'P', value: 'P', count: keyCounts.P, color: '#1a9b54', bg: '#eefbf3' },
                                        { label: 'WA', value: 'WA', count: keyCounts.WA, color: '#1769d6', bg: '#eef4ff' },
                                        { label: 'WI', value: 'WI', count: keyCounts.WI, color: '#e6a23c', bg: '#fff8ed' },
                                        { label: 'M', value: 'M', count: keyCounts.M, color: '#7c3aed', bg: '#f5f0ff' },
                                        { label: 'No Key', value: 'notSet', count: keyCounts.notSet, color: '#64748b', bg: '#f1f5f9' },
                                    ];
                                    const activeKeyFilter = studentKeyFilters[studentKey];
                                    const displayRecords = activeKeyFilter
                                        ? records.filter((rec) => {
                                            const idx = getActivityKeyIndex(rec.key);
                                            return activeKeyFilter === 'notSet'
                                                ? idx === -1
                                                : KEY_SEQUENCE[idx] === activeKeyFilter;
                                        })
                                        : records;
                                    return (
                                        <React.Fragment key={studentKey}>
                                            <TableRow className={`dashboard-table-no-hover ${classes.groupHeaderRow}`}>
                                                <TableCell
                                                    className={classes.groupHeaderCell}
                                                    colSpan={visibleColumnCount}
                                                    onClick={() => toggleStudentActivityRows(studentKey)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            toggleStudentActivityRows(studentKey);
                                                        }
                                                    }}
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-expanded={expanded}
                                                >
                                                    <Box className={classes.groupHeaderInner}>
                                                        <Box display="flex" alignItems="center" gridGap={10}>
                                                            <Avatar className={classes.studentAvatar}>
                                                                <PersonIcon style={{ fontSize: 18 }} />
                                                            </Avatar>
                                                            <Typography style={{ fontWeight: 700, color: '#0f2d4d', textTransform: 'uppercase', fontSize: '0.9rem' }}>
                                                                {studentName || 'Unknown Student'}
                                                            </Typography>
                                                            <span className={classes.activityCountBadge}>
                                                                {records.length} {records.length === 1 ? 'Activity' : 'Activities'}
                                                            </span>
                                                            <Box display="flex" alignItems="center" gridGap={6} flexWrap="wrap">
                                                                {keySummary.map((item) => {
                                                                    const isActive = activeKeyFilter === item.value;
                                                                    const isDisabled = item.count === 0;
                                                                    return (
                                                                        <span
                                                                            key={item.label}
                                                                            role="button"
                                                                            tabIndex={isDisabled ? -1 : 0}
                                                                            title={isDisabled
                                                                                ? `${item.label}: ${item.count}`
                                                                                : `Show ${item.label} activities (${item.count})`}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                if (isDisabled) return;
                                                                                toggleStudentKeyFilter(studentKey, item.value);
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                if (isDisabled) return;
                                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    toggleStudentKeyFilter(studentKey, item.value);
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: 4,
                                                                                padding: '2px 8px',
                                                                                borderRadius: 999,
                                                                                fontSize: '0.72rem',
                                                                                fontWeight: 700,
                                                                                color: isActive ? '#ffffff' : item.color,
                                                                                backgroundColor: isActive ? item.color : item.bg,
                                                                                border: `1px solid ${isActive ? item.color : `${item.color}33`}`,
                                                                                opacity: isDisabled ? 0.45 : 1,
                                                                                cursor: isDisabled ? 'default' : 'pointer',
                                                                                boxShadow: isActive ? `0 2px 6px ${item.color}55` : 'none',
                                                                            }}
                                                                        >
                                                                            {item.label}: {item.count}
                                                                        </span>
                                                                    );
                                                                })}
                                                                {activeKeyFilter && (
                                                                    <span
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Clear key filter"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            toggleStudentKeyFilter(studentKey, activeKeyFilter);
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                toggleStudentKeyFilter(studentKey, activeKeyFilter);
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            padding: '2px 8px',
                                                                            borderRadius: 999,
                                                                            fontSize: '0.72rem',
                                                                            fontWeight: 700,
                                                                            color: '#64748b',
                                                                            backgroundColor: '#f1f5f9',
                                                                            border: '1px solid #cbd5e1',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        Clear
                                                                    </span>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                        {expanded ? (
                                                            <ExpandMoreIcon style={{ color: '#46566b' }} />
                                                        ) : (
                                                            <ChevronRightIcon style={{ color: '#46566b' }} />
                                                        )}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                            {expanded
                                                ? displayRecords.flatMap((activity, recordIndex) => {
                                                    const isOverdue = highlightPrevWeek && shouldHighlightRow(activity);
                                                    const isObsExpanded = observationExpanded[activity._id] === true;
                                                    const hasObservation = hasSavedRemarks(activity);
                                                    const rowKey = getActivityRowKey(activity, group, recordIndex);

                                                    return [
                                                        <TableRow
                                                            key={rowKey}
                                                            style={{ backgroundColor: isOverdue ? '#ffebee' : 'transparent' }}
                                                        >
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    color="primary"
                                                                    size="small"
                                                                    checked={selectedIdSet.has(String(activity._id))}
                                                                    onChange={() => toggleActivitySelection(activity._id)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    inputProps={{ 'aria-label': `Select activity ${activity.activityId?.activityName || ''}` }}
                                                                />
                                                            </TableCell>
                                                            {/* <TableCell>
                                                                {activity.classId ? (
                                                                    <Chip size="small" label={activity.classId.className} className={classes.classChip} />
                                                                ) : ''}
                                                            </TableCell> */}
                                                            {/* <TableCell>{activity.sectionId ? activity.sectionId.sectionName : ''}</TableCell> */}
                                                            {visibleCols.areaOfWork && (
                                                                <TableCell>{activity.superActivityId ? activity.superActivityId.superActivityName : ''}</TableCell>
                                                            )}
                                                            {visibleCols.listOfActivities && (
                                                                <TableCell>{activity.activityId ? activity.activityId.activityName : ''}</TableCell>
                                                            )}
                                                            {visibleCols.exercises && (
                                                                <TableCell>{activity.subActivityId ? activity.subActivityId.subActivityName : ''}</TableCell>
                                                            )}
                                                            {visibleCols.key && (
                                                                <TableCell>
                                                                    {renderKeyStatusStepper(activity)}
                                                                </TableCell>
                                                            )}
                                                                {visibleCols.observation && (
                                                                <TableCell
                                                                    className={
                                                                        hasSavedRemarks(activity)
                                                                            ? classes.observationCell
                                                                            : undefined
                                                                    }
                                                                >
                                                                    {renderObservationCell(activity)}
                                                                </TableCell>
                                                            )}
                                                            {visibleCols.startDate && (
                                                                <TableCell>
                                                                    <span className={classes.dateCell}>
                                                                        <CalendarTodayIcon style={{ fontSize: 14, color: '#9aa6b6' }} />
                                                                        {formatDate(activity.date)}
                                                                    </span>
                                                                </TableCell>
                                                            )}
                                                            {visibleCols.endDate && (
                                                                <TableCell>
                                                                    <span className={classes.dateCell}>
                                                                        <CalendarTodayIcon style={{ fontSize: 14, color: '#9aa6b6' }} />
                                                                        {formatDate(activity.endDate)}
                                                                    </span>
                                                                </TableCell>
                                                            )}
                                                        
                                                            {visibleCols.status && (
                                                                <TableCell>
                                                                    {!isActivityPublishedToParent(activity) ? (
                                                                        <Chip
                                                                            size="small"
                                                                            label="Draft"
                                                                            className={classes.statusDraft}
                                                                            onClick={() => handlePublicStatusChange(activity, 'publish')}
                                                                        />
                                                                    ) : (
                                                                        <Chip
                                                                            size="small"
                                                                            label="Published"
                                                                            className={classes.statusPublished}
                                                                            onClick={() => handlePublicStatusChange(activity, 'draft')}
                                                                        />
                                                                    )}
                                                                </TableCell>
                                                            )}
                                                            {visibleCols.images && (
                                                                <TableCell>
                                                                    {renderActivityImagesCell(activity)}
                                                                </TableCell>
                                                            )}
                                                            <TableCell align="center">
                                                                <IconButton size="small" onClick={(e) => openActionMenu(e, activity, group)}>
                                                                    <MoreVertIcon fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>,
                                                        isObsExpanded && hasObservation && visibleCols.observation
                                                            ? renderObservationExpandRow(activity)
                                                            : null,
                                                    ].filter(Boolean);
                                                })
                                                : null}
                                        </React.Fragment>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>

                {activityTableLoading ? (
                    <Box className={classes.tableSkeletonPagination}>
                        <Skeleton variant="text" width={96} height={20} animation="wave" classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="rect" width={52} height={28} animation="wave" style={{ borderRadius: 6 }} classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="text" width={72} height={20} animation="wave" classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="circle" width={28} height={28} animation="wave" classes={{ root: classes.skeletonBar }} />
                        <Skeleton variant="circle" width={28} height={28} animation="wave" classes={{ root: classes.skeletonBar }} />
                    </Box>
                ) : (
                <TablePagination
                    component="div"
                    rowsPerPageOptions={[20, 50, 100]}
                    count={activityTotal}
                    page={pg}
                    onPageChange={handleChangePage}
                    rowsPerPage={rpg}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                )}
            </Card>

            {/* Column visibility menu */}
            <Menu
                anchorEl={columnMenuAnchor}
                open={Boolean(columnMenuAnchor)}
                onClose={() => setColumnMenuAnchor(null)}
            >
                {columnConfig.map((col) => (
                    <MenuItem
                        key={col.id}
                        onClick={() => setVisibleCols((v) => ({ ...v, [col.id]: !v[col.id] }))}
                    >
                        <Checkbox checked={visibleCols[col.id]} size="small" color="primary" />
                        {col.label}
                    </MenuItem>
                ))}
            </Menu>

            {/* Image add options menu */}
            <Menu
                anchorEl={imageAddMenu.anchorEl}
                open={Boolean(imageAddMenu.anchorEl)}
                onClose={closeImageAddMenu}
            >
                <MenuItem onClick={handleImageAddMenuUpload}>
                    <CloudUploadIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} />
                    Upload Images
                </MenuItem>
                <MenuItem onClick={handleImageAddMenuStore}>
                    <PhotoLibraryIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} />
                    From Images Store
                </MenuItem>
            </Menu>

            {/* Row actions menu */}
            <Menu
                anchorEl={actionMenu.anchorEl}
                open={Boolean(actionMenu.anchorEl)}
                onClose={closeActionMenu}
            >
                <MenuItem
                    onClick={() => { editActivity(actionMenu.activity, false, actionMenu.group); closeActionMenu(); }}
                >
                    <EditIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} /> Edit
                </MenuItem>
                <MenuItem
                    onClick={() => { editActivity(actionMenu.activity, true, actionMenu.group); closeActionMenu(); }}
                >
                    <AddIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} /> Add More
                </MenuItem>
                {actionMenu.activity && isActivityPublishedToParent(actionMenu.activity) && (
                    <MenuItem
                        onClick={() => {
                            handlePublicStatusChange(actionMenu.activity, 'draft');
                            closeActionMenu();
                        }}
                    >
                        <EditIcon fontSize="small" style={{ marginRight: 10, color: '#1769d6' }} /> Move to Draft
                    </MenuItem>
                )}
                <MenuItem
                    onClick={() => {
                        const a = actionMenu.activity;
                        const g = actionMenu.group;
                        const record = g?.activityRecordsId?.find((r) => r.activityId?._id === a?.activityId?._id);
                        setSelectedHistory(record?.statusHistory || a?.statusHistory || []);
                        setOpenHistory(true);
                        closeActionMenu();
                    }}
                >
                    <HistoryIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} /> History
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={() => { handleDeleteClick(actionMenu.activity._id); closeActionMenu(); }}
                    style={{ color: '#dc3545' }}
                >
                    <DeleteIcon fontSize="small" style={{ marginRight: 10 }} /> Delete
                </MenuItem>
            </Menu>

            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                PaperProps={{ className: classes.planDialogPaper }}
            >
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {activity._id ? 'Edit Plan Activity' : 'Plan Activity'}
                    </span>
                    <IconButton size="small" onClick={handleClose} disabled={addActivityLoading}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent className={classes.dialogBody}>
                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Schedule</Typography>
                            <Box className={classes.dateRow}>
                                <Box className={classes.dateFieldWrap}>
                                    <span className={classes.dateFieldLabel}>Start Date *</span>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        className={classes.dateField}
                                        id="date"
                                        name="date"
                                        autoFocus
                                        required
                                        type="date"
                                        error={formik.touched.date && Boolean(formik.errors.date)}
                                        value={formik.values.date}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            if (formik.values.endDate && e.target.value && new Date(e.target.value) > new Date(formik.values.endDate)) {
                                                formik.setFieldValue('endDate', '');
                                            }
                                        }}
                                        helperText={formik.touched.date && formik.errors.date ? formik.errors.date : ' '}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                                <Box className={classes.dateFieldWrap}>
                                    <span className={classes.dateFieldLabel}>End Date *</span>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        className={classes.dateField}
                                        id="endDate"
                                        name="endDate"
                                        required
                                        type="date"
                                        inputProps={{ min: formik.values.date || undefined }}
                                        value={formik.values.endDate}
                                        onChange={(e) => {
                                            const selectedEndDate = e.target.value;
                                            if (!formik.values.date || new Date(selectedEndDate) >= new Date(formik.values.date)) {
                                                formik.handleChange(e);
                                            } else {
                                                setMessageDialogContent({
                                                    title: 'Validation Error',
                                                    message: 'End date must be greater than or equal to start date',
                                                    type: 'error'
                                                });
                                                setOpenMessageDialog(true);
                                            }
                                        }}
                                        error={(formik.touched.endDate && Boolean(formik.errors.endDate)) || (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date))}
                                        helperText={
                                            formik.touched.endDate && formik.errors.endDate
                                                ? formik.errors.endDate
                                                : (formik.values.endDate && formik.values.date && new Date(formik.values.endDate) < new Date(formik.values.date)
                                                    ? 'End date must be >= start date'
                                                    : ' ')
                                        }
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                            </Box>
                        </Box>

                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Class &amp; Students</Typography>
                            <Box mb={1.5}>
                                <span className={classes.fieldLabel}>Select Class *</span>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    required
                                    error={formik.touched.classId && Boolean(formik.errors.classId)}
                                >
                                    <Select
                                        id="demo-simple-select"
                                        name="classId"
                                        displayEmpty
                                        value={formik.values.classId}
                                        onChange={e => {
                                            formik.handleChange(e);
                                            formik.setFieldValue('sectionId', '');
                                            loadDialogSectionList(e.target.value);
                                            getStudentList(e, null, '');
                                            getAllSuperActivityTabelMultiple(e);
                                            if (!e.target.value || e.target.value === '') {
                                                formik.setFieldValue('studentId', []);
                                                setGroupedUnmasteredActivities({});
                                                setFilteredUnmasteredActivities([]);
                                            } else {
                                                const userDetails = JSON.parse(localStorage.getItem("userDetail"));
                                                fetchAndGroupUnmasteredActivities(e.target.value, userDetails.schooleId);
                                            }
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Class</em></MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.classId && formik.errors.classId && (
                                        <FormHelperText>{formik.errors.classId}</FormHelperText>
                                    )}
                                </FormControl>
                            </Box>

                            <Box mb={1.5}>
                                <span className={classes.fieldLabel}>Select Section (Optional)</span>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        id="dialog-section-select"
                                        name="sectionId"
                                        displayEmpty
                                        value={formik.values.sectionId || ''}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            if (formik.values.classId) {
                                                // Pass '' (not undefined) when cleared so we load ALL
                                                // class students instead of falling back to the page filter.
                                                getStudentList({ target: { value: formik.values.classId } }, null, e.target.value || '');
                                            }
                                        }}
                                        disabled={!formik.values.classId || dialogSectionList.length === 0}
                                    >
                                        {!(userDetails?.role === 'TEACHER' && userDetails?.sectionId) && (
                                            <MenuItem value=""><em>None</em></MenuItem>
                                        )}
                                        {dialogSectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>

                            <Box mb={1}>
                                <span className={classes.fieldLabel}>Student Name</span>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        id="studentName-select"
                                        name="studentId"
                                        multiple
                                        displayEmpty
                                        disabled={formik.values.isEdit || !formik.values.classId || formik.values.classId === ''}
                                        value={formik.values.studentId}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            if (!formik.values.isEventForAllStudent) {
                                                const selectedStudentIds = e.target.value;
                                                if (selectedStudentIds && selectedStudentIds.length > 0) {
                                                    const filtered = [];
                                                    selectedStudentIds.forEach(studentId => {
                                                        if (groupedUnmasteredActivities[studentId]) {
                                                            filtered.push(...groupedUnmasteredActivities[studentId]);
                                                        }
                                                    });
                                                    setFilteredUnmasteredActivities(filtered);
                                                } else {
                                                    setFilteredUnmasteredActivities([]);
                                                }
                                            }
                                            try {
                                                const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
                                                const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
                                                ActivityService.getExistingActivityKeys({
                                                    schooleId,
                                                    classId: formik.values.classId,
                                                    sectionId: formik.values.sectionId || null,
                                                    studentId: e.target.value,
                                                    isEventForAllStudent: Boolean(formik.values.isEventForAllStudent),
                                                }).then((r) => {
                                                    const data = r?.data || r;
                                                    const keys = Array.isArray(data?.keys) ? data.keys : [];
                                                    setExistingKeySet(new Set(keys));
                                                    setExistingKeyStudents(data?.byKey || {});
                                                }).catch(() => setExistingKeySet(new Set()));
                                            } catch (err) {
                                                setExistingKeySet(new Set());
                                                setExistingKeyStudents({});
                                            }
                                        }}
                                        renderValue={(selected) => {
                                            if (!formik.values.classId || formik.values.classId === '') {
                                                return <span style={{ color: '#9aa6b6' }}>Please select a class first</span>;
                                            }
                                            const selectedNames = studentList
                                                .filter(({ _id }) => selected.includes(_id))
                                                .map(({ studentName }) => studentName);
                                            return selectedNames.length > 0 ? selectedNames.join(", ") : <span style={{ color: '#9aa6b6' }}>Select students</span>;
                                        }}
                                    >
                                        {studentList.length === 0 ? (
                                            <MenuItem disabled value="">
                                                {formik.values.classId ? 'No students found' : 'Please select a class first'}
                                            </MenuItem>
                                        ) : (
                                            studentList.map(({ _id, studentName }) => (
                                                <MenuItem key={_id} value={_id}>
                                                    {studentName}
                                                </MenuItem>
                                            ))
                                        )}
                                    </Select>
                                </FormControl>
                            </Box>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isEventForAllStudent"
                                        id="terms"
                                        color="primary"
                                        value={formik.values.isEventForAllStudent}
                                        checked={formik.values.isEventForAllStudent}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            if (e.target.checked) {
                                                const allActivities = [];
                                                Object.values(groupedUnmasteredActivities).forEach(activities => {
                                                    allActivities.push(...activities);
                                                });
                                                setFilteredUnmasteredActivities(allActivities);
                                            } else {
                                                const selectedStudentIds = formik.values.studentId || [];
                                                if (selectedStudentIds.length > 0) {
                                                    const filtered = [];
                                                    selectedStudentIds.forEach(studentId => {
                                                        if (groupedUnmasteredActivities[studentId]) {
                                                            filtered.push(...groupedUnmasteredActivities[studentId]);
                                                        }
                                                    });
                                                    setFilteredUnmasteredActivities(filtered);
                                                } else {
                                                    setFilteredUnmasteredActivities([]);
                                                }
                                            }
                                            try {
                                                const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
                                                const schooleId = userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
                                                ActivityService.getExistingActivityKeys({
                                                    schooleId,
                                                    classId: formik.values.classId,
                                                    sectionId: formik.values.sectionId || null,
                                                    studentId: formik.values.studentId || [],
                                                    isEventForAllStudent: Boolean(e.target.checked),
                                                }).then((r) => {
                                                    const data = r?.data || r;
                                                    const keys = Array.isArray(data?.keys) ? data.keys : [];
                                                    setExistingKeySet(new Set(keys));
                                                    setExistingKeyStudents(data?.byKey || {});
                                                }).catch(() => setExistingKeySet(new Set()));
                                            } catch (err) {
                                                setExistingKeySet(new Set());
                                                setExistingKeyStudents({});
                                            }
                                        }}
                                    />
                                }
                                label="For All Class Students"
                                style={{ marginLeft: 0 }}
                            />
                        </Box>
                        {/* Display unmastered activities for selected students or all if "For All Class Students" is checked */}
                        {/* {(() => {
                            // Get activities to display - all if "For All Class Students" is checked, otherwise filtered
                            const activitiesToDisplay = formik.values.isEventForAllStudent 
                                ? Object.values(groupedUnmasteredActivities).flat()
                                : filteredUnmasteredActivities;
                            
                            return activitiesToDisplay.length > 0 && (
                                <FormControl variant="standard" style={{ width: 423, marginTop: '16px' }}>
                                    <InputLabel id="unmastered-activities-label">Unmastered Activities</InputLabel>
                                    <Select
                                        labelId="unmastered-activities-label"
                                        id="unmastered-activities-select"
                                        label="Unmastered Activities"
                                        multiple
                                        value={[]}
                                        renderValue={() => `${activitiesToDisplay.length} unmastered activity(ies) found`}
                                        style={{ maxHeight: '200px', overflowY: 'auto' }}
                                    >
                                        {activitiesToDisplay.map((activity, index) => {
                                        const studentName = activity.studentId?.fullName || 
                                            (activity.studentId?.firstName && activity.studentId?.lastName 
                                                ? `${activity.studentId.firstName} ${activity.studentId.lastName}` 
                                                : 'Unknown Student');
                                        const activityName = activity.activityId?.activityName || 'Unknown Activity';
                                        const subActivityName = activity.subActivityId?.subActivityName || '';
                                        const superActivityName = activity.superActivityId?.superActivityName || '';
                                        const keyText = activity.keyText || activity.key || '';
                                        
                                        return (
                                            <MenuItem key={index} value={activity._id} disabled>
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                    <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                                                        {studentName}
                                                    </div>
                                                    <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                                        <div><strong>Area:</strong> {superActivityName}</div>
                                                        <div><strong>Activity:</strong> {activityName}</div>
                                                        {subActivityName && <div><strong>Exercise:</strong> {subActivityName}</div>}
                                                        <div><strong>Status:</strong> <span style={{ color: '#ff9800', fontWeight: '600' }}>{keyText}</span></div>
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        );
                                        })}
                                    </Select>
                                </FormControl>
                            );
                        })()} */}
                        
                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Activities</Typography>
                        {formik.values.isEdit ? (
                            <>
                                <Box mb={1.5}>
                                    <span className={classes.fieldLabel}>Area Of Work</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            id="superActivityName"
                                            name="superActivityId"
                                            displayEmpty
                                            onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                            value={formik.values.superActivityId}
                                            error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                        >
                                            <MenuItem value=""><em>Select area</em></MenuItem>
                                            {addSuperActivityList.map(({ _id, superActivityName }) => (
                                                <MenuItem key={_id} value={String(_id)}>{superActivityName}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.superActivityId && formik.errors.superActivityId && (
                                            <FormHelperText error>{formik.errors.superActivityId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                                <Box mb={1.5}>
                                    <span className={classes.fieldLabel}>List Of Activities</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            id="activityName"
                                            name="activityId"
                                            displayEmpty
                                            onChange={e => { formik.handleChange(e); getSubActivityList(e) }}
                                            value={formik.values.activityId}
                                            error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                        >
                                            <MenuItem value=""><em>Select activity</em></MenuItem>
                                            {addActivityList.map(({ _id, activityName }) => (
                                                <MenuItem key={_id} value={String(_id)}>{activityName}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.activityId && formik.errors.activityId && (
                                            <FormHelperText error>{formik.errors.activityId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                                <Box mb={1.5}>
                                    <span className={classes.fieldLabel}>Exercise</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            id="subActivityId"
                                            name="subActivityId"
                                            displayEmpty
                                            value={formik.values.subActivityId}
                                            onChange={formik.handleChange}
                                            error={formik.touched.subActivityId && Boolean(formik.errors.subActivityId)}
                                        >
                                            <MenuItem value=""><em>Select exercise</em></MenuItem>
                                            {subActivityList.map(({ _id, subActivityName }) => (
                                                <MenuItem key={_id} value={String(_id)}>{subActivityName}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.subActivityId && formik.errors.subActivityId && (
                                            <FormHelperText error>{formik.errors.subActivityId}</FormHelperText>
                                        )}
                                    </FormControl>
                                </Box>
                            </>
                        ) : (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    id="search-activities"
                                    placeholder="Search activities..."
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ marginBottom: 12 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={10} mb={1}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={showOnlyExisting}
                                                onChange={(e) => setShowOnlyExisting(e.target.checked)}
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={<span style={{ fontSize: '0.875rem', color: '#46566b' }}>Show only already added</span>}
                                    />
                                    <Typography variant="caption" style={{ color: '#64748b' }}>
                                        (Already added items are highlighted in light red)
                                    </Typography>
                                </Box>
                                <Box className={classes.activityTreeWrap}>
                                    <TreeView
                                        defaultCollapseIcon={<ExpandMoreIcon />}
                                        defaultExpandIcon={<ChevronRightIcon />}
                                    >
                                        {selectedActivities.map((node) => renderTree(node))}
                                    </TreeView>
                                </Box>
                            </>
                        )}
                        </Box>
                        <Box className={classes.formSection}>
                            <Typography className={classes.sectionLabel}>Details</Typography>
                            <Box mb={1.5}>
                                <span className={classes.fieldLabel}>Select Key</span>
                                <FormControl variant="outlined" size="small" fullWidth>
                                    <Select
                                        id="demo-simple-select-standard"
                                        name="key"
                                        displayEmpty
                                        value={formik.values.key}
                                        onChange={formik.handleChange}
                                        error={formik.touched.key && Boolean(formik.errors.key)}
                                    >
                                        <MenuItem value=""><em>Select key</em></MenuItem>
                                        {keyOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText style={{ color: '#64748b' }}>
                                        Add the activity future without requiring key selection, and allow editing later if the student has performed any key.
                                    </FormHelperText>
                                </FormControl>
                            </Box>
                        </Box>

                    </DialogContent>
                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} disabled={addActivityLoading} className={classes.cancelBtn}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            onClick={verifyeetnt}
                            disabled={addActivityLoading}
                            variant="contained"
                            className={classes.saveBtn}
                        >
                            {addActivityLoading ? (
                                <>
                                    <CircularProgress size={18} style={{ marginRight: 8, color: '#fff' }} />
                                    Adding...
                                </>
                            ) : (
                                activity._id ? 'Update' : 'Add'
                            )}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                open={activityNoteDialog.open}
                onClose={() => setActivityNoteDialog({ open: false, title: "", text: "" })}
                maxWidth="sm"
                fullWidth
                ModalProps={{ style: { zIndex: 2000 } }}
            >
                <DialogTitle>{activityNoteDialog.title || "Note"}</DialogTitle>
                <DialogContent dividers>
                    <Typography style={{ whiteSpace: "pre-wrap", fontSize: 15, lineHeight: 1.5 }}>
                        {activityNoteDialog.text || "—"}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setActivityNoteDialog({ open: false, title: "", text: "" })}
                        color="primary"
                        variant="contained"
                        style={{ backgroundColor: "rgb(15 59 98)" }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openHistory} onClose={() => setOpenHistory(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Key Status History</DialogTitle>
                <DialogContent dividers style={{ maxHeight: '300px' }}>
                    {selectedHistory.length > 0 ? (
                        selectedHistory
                            .sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt))
                            .map((history, index) => (
                                <div
                                    key={index}
                                    style={{
                                        background: '#f1f5f8',
                                        borderRadius: '6px',
                                        padding: '8px',
                                        marginBottom: '8px',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    <span style={getKeyStatusStyle(history.key)}>
                                        {getKeyStatusText(history.key)}
                                    </span>
                                    <div style={{ fontSize: '0.75rem', color: '#555' }}>
                                        {history.changedAt ? new Date(history.changedAt).toLocaleString() : '-'}
                                    </div>
                                </div>
                            ))
                    ) : (
                        <div style={{ color: '#999', fontSize: '0.85rem' }}>No history available.</div>
                    )}
                </DialogContent>
            </Dialog>

            <Dialog 
                open={openMessageDialog} 
                onClose={() => setOpenMessageDialog(false)} 
                maxWidth="sm" 
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                    }
                }}
            >
                <DialogTitle style={{ 
                    backgroundColor: messageDialogContent.type === 'success' ? '#d4edda' : messageDialogContent.type === 'error' ? '#f8d7da' : '#d1ecf1',
                    color: messageDialogContent.type === 'success' ? '#155724' : messageDialogContent.type === 'error' ? '#721c24' : '#0c5460',
                    padding: '20px 24px',
                    borderBottom: `2px solid ${messageDialogContent.type === 'success' ? '#28a745' : messageDialogContent.type === 'error' ? '#dc3545' : '#17a2b8'}`,
                    fontWeight: '600',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    {messageDialogContent.type === 'success' && '✓'}
                    {messageDialogContent.type === 'error' && '✕'}
                    {messageDialogContent.type === 'info' && 'ℹ'}
                    {messageDialogContent.title}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <div style={{ 
                        color: '#333',
                        fontSize: '15px',
                        lineHeight: '1.6'
                    }}>
                        {normalizeDialogMessage(messageDialogContent.message).split('\n').map((line, index) => {
                            // Check if line starts with bullet point and contains student name
                            if (line.trim().startsWith('•')) {
                                const studentName = line.trim().substring(1).trim(); // Remove bullet and trim
                                return (
                                    <div key={index} style={{ marginBottom: '4px' }}>
                                        • <strong style={{ fontWeight: '700' }}>{studentName}</strong>
                                    </div>
                                );
                            }
                            // Return empty line or regular line
                            if (line.trim() === '') {
                                return <div key={index} style={{ marginBottom: '8px' }}></div>;
                            }
                            return <div key={index} style={{ marginBottom: '4px' }}>{line}</div>;
                        })}
                    </div>
                </DialogContent>
                <DialogActions style={{ 
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6'
                }}>
                    <Button 
                        onClick={() => setOpenMessageDialog(false)}
                        variant="contained"
                        style={{
                            backgroundColor: messageDialogContent.type === 'success' ? '#28a745' : messageDialogContent.type === 'error' ? '#dc3545' : '#17a2b8',
                            color: 'white',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 24px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={keyUpdateDialog.open}
                onClose={handleKeyUpdateCancel}
                maxWidth="sm"
                fullWidth
                PaperProps={{ style: { borderRadius: '12px' } }}
            >
                <DialogTitle style={{
                    backgroundColor: '#eef4ff',
                    color: '#0f2d4d',
                    padding: '20px 24px',
                    borderBottom: '1px solid #d6e4ff',
                    fontWeight: 600,
                    fontSize: '18px',
                }}>
                    {keyUpdateDialog.deselect ? 'Confirm Deselect' : 'Confirm Key Update'}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <Typography style={{ color: '#333', fontSize: '15px', lineHeight: 1.6 }}>
                        {keyUpdateDialog.deselect ? (
                            <>
                                Deselect <strong>{keyUpdateDialog.currentLabel || keyUpdateDialog.currentKey}</strong> for this activity?
                            </>
                        ) : (
                            <>
                                Update key from <strong>{keyUpdateDialog.currentLabel || keyUpdateDialog.currentKey}</strong> to{' '}
                                <strong>{keyUpdateDialog.nextLabel || keyUpdateDialog.nextKey}</strong> for this activity?
                            </>
                        )}
                    </Typography>
                </DialogContent>
                <DialogActions style={{
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6',
                }}>
                    <Button
                        onClick={handleKeyUpdateCancel}
                        disabled={Boolean(updatingKeyId)}
                        style={{ textTransform: 'none', fontWeight: 500 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleKeyUpdateConfirm}
                        variant="contained"
                        disabled={Boolean(updatingKeyId)}
                        style={{
                            backgroundColor: '#1769d6',
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 500,
                            borderRadius: 6,
                        }}
                    >
                        {updatingKeyId
                            ? (keyUpdateDialog.deselect ? 'Removing...' : 'Updating...')
                            : (keyUpdateDialog.deselect ? 'Deselect' : 'Update')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={observationDialog.open}
                onClose={closeObservationDialog}
                maxWidth="sm"
                fullWidth
                PaperProps={{ style: { borderRadius: 12 } }}
            >
                <DialogTitle style={{ fontWeight: 700, color: '#0f2d4d' }}>
                    {hasSavedRemarks(observationDialog.activity) ? 'Edit Observation' : 'Add Observation'}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        maxRows={10}
                        variant="outlined"
                        size="small"
                        placeholder="Enter observation..."
                        value={observationDialog.text}
                        onChange={(e) => handleObservationDialogChange(e.target.value)}
                        disabled={observationDialog.saving}
                        autoFocus
                    />
                </DialogContent>
                <DialogActions style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                    <Button
                        onClick={closeObservationDialog}
                        disabled={observationDialog.saving}
                        style={{ textTransform: 'none' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={saveObservationDialog}
                        color="primary"
                        variant="contained"
                        disabled={
                            observationDialog.saving
                            || (!hasSavedRemarks(observationDialog.activity) && !observationDialog.text.trim())
                        }
                        style={{ textTransform: 'none', backgroundColor: 'rgb(15, 59, 98)' }}
                    >
                        {observationDialog.saving ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={imagesStoreDialog.open}
                onClose={closeImagesStoreDialog}
                maxWidth="md"
                fullWidth
                PaperProps={{ style: { borderRadius: 12 } }}
            >
                <DialogTitle style={{ fontWeight: 700, color: '#0f2d4d' }}>
                    Add Media from Images Store
                </DialogTitle>
                <DialogContent dividers style={{ padding: '16px 20px' }}>
                    {imagesStoreDialog.loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                            <CircularProgress />
                        </Box>
                    ) : imagesStoreDialog.error ? (
                        <Typography color="error">{imagesStoreDialog.error}</Typography>
                    ) : (() => {
                        const dialogActivity = imagesStoreDialog.activity;
                        const existingImages = dialogActivity ? getActivityImageUrls(dialogActivity) : [];
                        const existingVideos = dialogActivity ? getActivityVideoUrls(dialogActivity) : [];
                        const remainingImageSlots = MAX_ACTIVITY_IMAGES - existingImages.length;
                        const remainingVideoSlots = MAX_ACTIVITY_VIDEOS - existingVideos.length;
                        const visibleMedia = getVisibleStoreMedia(
                            imagesStoreDialog.imagesStoreRows,
                            imagesStoreDialog.selectedStoreId,
                        );
                        const storeMediaCounts = countStoreMedia(imagesStoreDialog.imagesStoreRows);

                        return (
                            <Box display="flex" flexDirection="column" style={{ gap: 12 }}>
                                <Typography variant="body2" style={{ color: '#46566b' }}>
                                    Select images and/or videos to add (
                                    {remainingImageSlots} image slot{remainingImageSlots !== 1 ? 's' : ''},
                                    {' '}
                                    {remainingVideoSlots} video slot{remainingVideoSlots !== 1 ? 's' : ''} remaining).
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box className={classes.imagesStoreLeftPanel}>
                                            <List disablePadding>
                                                <ListItem
                                                    button
                                                    selected={imagesStoreDialog.selectedStoreId === IMAGES_STORE_ALL_KEY}
                                                    className={classes.imagesStoreListItem}
                                                    onClick={() => setImagesStoreDialog((prev) => ({
                                                        ...prev,
                                                        selectedStoreId: IMAGES_STORE_ALL_KEY,
                                                    }))}
                                                >
                                                    <ListItemText
                                                        primary="All Media"
                                                        secondary={`${storeMediaCounts.images} images · ${storeMediaCounts.videos} videos`}
                                                    />
                                                </ListItem>
                                                {imagesStoreDialog.imagesStoreRows.map((row) => (
                                                    <ListItem
                                                        key={row._id}
                                                        button
                                                        selected={imagesStoreDialog.selectedStoreId === row._id}
                                                        className={classes.imagesStoreListItem}
                                                        onClick={() => setImagesStoreDialog((prev) => ({
                                                            ...prev,
                                                            selectedStoreId: row._id,
                                                        }))}
                                                    >
                                                        <ListItemText
                                                            primary={row.eventName || '—'}
                                                            secondary={`${(row.imageURL || []).length} image${(row.imageURL || []).length !== 1 ? 's' : ''} · ${(row.videoURL || []).length} video${(row.videoURL || []).length !== 1 ? 's' : ''}`}
                                                        />
                                                    </ListItem>
                                                ))}
                                                {imagesStoreDialog.imagesStoreRows.length === 0 ? (
                                                    <Typography
                                                        variant="caption"
                                                        color="textSecondary"
                                                        style={{ padding: 16, display: 'block' }}
                                                    >
                                                        No Images Store records for this class
                                                        {normalizeRefId(dialogActivity?.sectionId) || sectionId ? ' and section' : ''}.
                                                    </Typography>
                                                ) : null}
                                            </List>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        {imagesStoreDialog.selectedUrls.length > 0 ? (
                                            <Typography variant="caption" style={{ fontWeight: 600, display: 'block', marginBottom: 8 }}>
                                                Selected ({imagesStoreDialog.selectedUrls.length})
                                            </Typography>
                                        ) : null}
                                        <Box className={classes.imagesStoreGrid}>
                                            {visibleMedia.length === 0 ? (
                                                <Typography color="textSecondary" style={{ gridColumn: '1 / -1' }}>
                                                    No images or videos to display.
                                                </Typography>
                                            ) : (
                                                visibleMedia.map((item, index) => {
                                                    const isVideo = item.mediaType === 'video';
                                                    const existingUrls = isVideo ? existingVideos : existingImages;
                                                    const remainingSlots = isVideo ? remainingVideoSlots : remainingImageSlots;
                                                    const alreadyOnActivity = existingUrls.includes(item.url);
                                                    const isSelected = imagesStoreDialog.selectedUrls.includes(item.url);
                                                    const selectedOfType = imagesStoreDialog.selectedUrls.filter(
                                                        (url) => getMediaTypeFromUrl(url) === item.mediaType,
                                                    );
                                                    const selectionFull = selectedOfType.length >= remainingSlots;
                                                    const isDisabled = alreadyOnActivity || (!isSelected && selectionFull);
                                                    const cardClass = [
                                                        classes.imagesStoreCard,
                                                        isSelected ? classes.imagesStoreCardSelected : '',
                                                        isDisabled ? classes.imagesStoreCardDisabled : '',
                                                    ].filter(Boolean).join(' ');

                                                    return (
                                                        <Box
                                                            key={`${item.storeRecordId}-${item.mediaType}-${item.url}-${index}`}
                                                            className={cardClass}
                                                            onClick={() => {
                                                                if (!isDisabled) {
                                                                    toggleImagesStoreSelection(item.url, item.mediaType);
                                                                }
                                                            }}
                                                            role="button"
                                                            tabIndex={isDisabled ? -1 : 0}
                                                            onKeyDown={(e) => {
                                                                if ((e.key === 'Enter' || e.key === ' ') && !isDisabled) {
                                                                    e.preventDefault();
                                                                    toggleImagesStoreSelection(item.url, item.mediaType);
                                                                }
                                                            }}
                                                        >
                                                            {isSelected ? (
                                                                <CheckCircleIcon
                                                                    className={classes.imagesStoreCheck}
                                                                    fontSize="small"
                                                                />
                                                            ) : null}
                                                            {isVideo ? (
                                                                <Box className={classes.imagesStoreVideoThumb}>
                                                                    <PlayArrowIcon style={{ color: '#fff', fontSize: 32 }} />
                                                                </Box>
                                                            ) : (
                                                                <img
                                                                    src={item.url}
                                                                    alt={item.storeEventName}
                                                                    className={classes.imagesStoreThumb}
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                />
                                                            )}
                                                            <Typography
                                                                variant="caption"
                                                                noWrap
                                                                style={{ display: 'block', padding: '2px 4px', fontSize: '0.65rem' }}
                                                            >
                                                                {isVideo ? (
                                                                    <>
                                                                        <VideocamIcon style={{ fontSize: 10, verticalAlign: 'middle', marginRight: 2 }} />
                                                                        {item.storeEventName}
                                                                    </>
                                                                ) : item.storeEventName}
                                                            </Typography>
                                                        </Box>
                                                    );
                                                })
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        );
                    })()}
                </DialogContent>
                <DialogActions style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                    <Button
                        onClick={closeImagesStoreDialog}
                        disabled={imagesStoreDialog.saving}
                        style={{ textTransform: 'none' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={saveImagesFromStore}
                        color="primary"
                        variant="contained"
                        disabled={
                            imagesStoreDialog.saving
                            || imagesStoreDialog.loading
                            || imagesStoreDialog.selectedUrls.length === 0
                        }
                        style={{ textTransform: 'none', backgroundColor: 'rgb(15, 59, 98)' }}
                    >
                        {imagesStoreDialog.saving ? 'Adding...' : 'Add Selected'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={statusConfirmDialog.open}
                onClose={closeStatusConfirmDialog}
                maxWidth="xs"
                fullWidth
                PaperProps={{ style: { borderRadius: 12 } }}
            >
                <DialogTitle style={{ fontWeight: 700, color: '#0f2d4d' }}>
                    {statusConfirmDialog.publicStatus === 'publish' ? 'Publish activity?' : 'Move to draft?'}
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
                        <Typography variant="body2" style={{ color: '#46566b' }}>
                            <strong style={{ color: '#e65100' }}>Draft</strong> — stays in this table only. Not sent to parents.
                        </Typography>
                        <Typography variant="body2" style={{ color: '#46566b' }}>
                            <strong style={{ color: '#1a9b54' }}>Published</strong> — sent to parents. 
                        </Typography>
                        <Typography variant="body2" style={{ color: '#0f2d4d', marginTop: 4 }}>
                            {statusConfirmDialog.publicStatus === 'publish'
                                ? 'Publish this activity to parents?'
                                : 'Move this activity back to draft? Parents will no longer see it.'}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                    <Button onClick={closeStatusConfirmDialog} style={{ textTransform: 'none' }}>
                        Cancel
                    </Button>
                    <Button
                        onClick={confirmPublicStatusChange}
                        color="primary"
                        variant="contained"
                        style={{ textTransform: 'none' }}
                    >
                        {statusConfirmDialog.publicStatus === 'publish' ? 'Publish' : 'Move to Draft'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog 
                open={openDeleteDialog} 
                onClose={handleDeleteCancel} 
                maxWidth="sm" 
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                    }
                }}
            >
                <DialogTitle style={{ 
                    backgroundColor: '#fff3cd',
                    color: '#856404',
                    padding: '20px 24px',
                    borderBottom: '2px solid #ffc107',
                    fontWeight: '600',
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    ⚠️ Confirm Delete
                </DialogTitle>
                <DialogContent dividers style={{ padding: '20px 24px' }}>
                    <div style={{
                        color: '#333',
                        fontSize: '15px',
                        lineHeight: '1.6',
                    }}>
                        {pendingDeleteIds.length > 1 ? (
                            <>
                                Are you sure you want to delete <strong>{pendingDeleteIds.length} activities</strong>? This action cannot be undone.
                                <Box mt={2} component="ul" style={{ margin: '12px 0 0', paddingLeft: 20, maxHeight: 180, overflowY: 'auto' }}>
                                    {getActivityLabelsForIds(pendingDeleteIds).map((label, index) => (
                                        <li key={`delete-label-${index}`} style={{ marginBottom: 4 }}>{label}</li>
                                    ))}
                                </Box>
                            </>
                        ) : (
                            'Are you sure you want to delete this activity? This action cannot be undone.'
                        )}
                    </div>
                </DialogContent>
                <DialogActions style={{ 
                    padding: '16px 24px',
                    backgroundColor: '#f8f9fa',
                    borderTop: '1px solid #dee2e6'
                }}>
                    <Button 
                        onClick={handleDeleteCancel}
                        style={{
                            color: '#6c757d',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 20px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleDeleteConfirm}
                        variant="contained"
                        style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            fontWeight: '500',
                            textTransform: 'none',
                            padding: '8px 24px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                    >
                        Delete{pendingDeleteIds.length > 1 ? ` (${pendingDeleteIds.length})` : ''}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
}


